export default {
  locale: 'vi',
  fallbackLocale: 'vi',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  dateTimeFormats: {
    en: {
      short: {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false
      },
      long: {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
      }
    },
    vi: {
      short: {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false
      },
      long: {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
      }
    }
  },
  messages: {
    en: {
      common: {
        loading: 'Loading...',
        done: 'Done',
        copy: 'Copy',
        copied: 'Copied',
        download: 'Download',
        cancel: 'Cancel',
        close: 'Close',
      },
      // Language and theme controls
      language: {
        label: 'Language',
        select: 'Select Language'
      },
      theme: {
        label: 'Theme',
        select: 'Select Theme',
        light: 'Light',
        dark: 'Dark'
      },
      authentication: {
        title: 'Dashboard Authentication',
        username: 'Username',
        password: 'Password',
        submit: 'Login',
        sessionExpired: 'Your session has expired or has been terminated. Please login again.',
        social: {
          google: 'Sign in with Google',
          microsoft: 'Sign in with Microsoft'
        },
        validation: {
          usernameRequired: 'Username or email is required',
          emailInvalid: 'Please enter a valid email address',
          passwordRequired: 'Password is required',
          attemptsRemaining: 'attempts remaining'
        },
        errors: {
          userNotFound: 'Username or password is incorrect',
          wrongPassword: 'Incorrect password',
          accountLocked: 'Account is locked due to too many failed attempts',
          accountDeactivated: 'Account has been deactivated, please contact admin for support',
          generalError: 'An error occurred during login. Please try again.'
        },
        accountLocked: {
          title: 'Account Temporarily Locked',
          message: 'Your account has been temporarily locked due to too many failed login attempts.',
          countdownLabel: 'Time remaining until unlock:',
          unlockMessage: 'You can now attempt to log in again.',
          waitMessage: 'Please wait for the lockout period to expire.'
        },
        failedAttempts: {
          title: 'Login Failed',
          message: '{failed} failed attempt(s). {remaining} attempt(s) remaining before account lockout.'
        },
        generalError: {
          title: 'Login Error'
        },
        success: 'Login successful'
      },
      copyrightFooter: 'Copyright {year} CyRadar. All rights reserved.',
      markedIncidents: 'Marked as Incident',
      dontMarkedIncidents: 'not marked as Incident',
      actionsList: 'Actions List',
      hide: 'Hide',
      assign_placeholder: 'Choose user to assign note',
      forward_placeholder: 'Choose user to forward note',
      closed_message: 'closed the ticket at',
      pending_message: 'is pending',
      replyTo: 'Reply to',
      replied: 'replied',
      at: 'at',
      add_note_massage: 'Add A Note',
      created_ticket_massage: 'created the ticket for maintainer',
      assigned_to: 'assigned to',
      download_message: 'Click to download the attachment',
      reopen: 'Reopen',
      Unknow: 'Unknow',
      you: 'You',
      forward: 'Forward',
      addNote: 'Add Note',
      reply: 'Reply',
      infomation: 'Infomation',
      assignedTo: 'Assigned To',
      previous: 'Previous',
      next: 'Next',
      incidentsDetail: 'Incident Response Details',
      total: 'Total',
      changeStatus: 'Change Status',
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      maintainer: 'Maintainer',
      toDo: 'To Do',
      eventsViewer: 'Events Viewer',
      close: 'Close',
      createdAt: 'Created At',
      created: 'Created',
      alertToMaintainer: 'Alert After Creation',
      dontAlertToMaintainer: 'Don\'t Alert After Creation',
      remind: 'Set Deadline',
      dontRemind: 'Dont Set Deadline',
      deadline: 'Deadline',
      remindBeforeDeadline: 'Remind Before',
      events: 'Events',
      incidentsHistogram: 'Incident Response Histogram',
      unassigned: 'Unassigned',
      overdue: 'Overdue',
      pending: 'Pending',
      priority: 'Priority',
      closed: 'Closed',
      falsePositive: 'False Positive',
      inProcess: 'In Process',
      solved: 'Solved',
      add: 'Add',
      save: 'Save',
      customize: 'Customize',
      cancel: 'Cancel',
      confirm: 'Confirm',
      edit: 'Update',
      remove: 'Remove',
      delete: 'Delete',
      activate: 'Activate',
      deactivate: 'Deactivate',
      stt: 'No.',
      active: 'Active',
      inactive: 'Inactive',
      sslEnabled: 'SSL: Enabled',
      sslDisabled: 'SSL: Disabled',
      characters: 'characters',
      random: 'Random',
      copy: 'Copy',
      query: 'Query',
      schedule: 'Schedule',
      refresh: 'Refresh',
      derived: 'Derived',
      name: 'Name',
      title: 'Title',
      description: 'Description',
      details: 'Details',
      enabled: 'Enabled',
      disabled: 'Disabled',
      creator: 'Creator',
      operator: 'Operator',
      value: 'Value',
      key: 'Key',
      lastAlert: 'Last Alert',
      settings: 'Settings',
      actions: 'Actions',
      loading: 'Loading...',
      ticketUpdateNotiSuccess: 'The ticket has been refreshed',
      ticketUpdateNoti: 'The ticket has been updated. Click sync to refresh',
      editWarning: 'you are editing another item. Are you sure you want to skip this item?',
      rus: 'Are you sure?',
      email: 'Email',
      protocol: 'Protocol',
      port: 'Port',
      accessIPs: 'Access IPs',
      types: 'Types',
      type: 'Type',
      index: 'Index',
      sourceType: 'Source Type',
      token: 'Token',
      delimiter: 'Event Delimiter',
      field_delimiter: 'Field Delimiter',
      comment: 'Comment',
      time: 'Time',
      fields: 'Fields',
      field: 'Field',
      format: 'Format',
      regexp: 'RegEx',
      autoDetect: 'Auto-Detection',
      autoFill: 'Auto-Filling',
      maxSize: 'Max Size',
      currentSize: 'Current Size',
      size: 'Current Size/Max Size',
      storageDuration: 'Storage Duration/Max Storage Duration',
      unit: 'Unit',
      modules: 'Modules',
      activeModules: 'Active Modules',
      lastEvent: 'Last Event',
      streams: 'Streams',
      paths: 'Paths',
      excludes: 'Excludes',
      intervals: 'Intervals',
      scopes: 'Scopes',
      role: 'Role',
      password: 'Password',
      oldPassword: 'Old Password',
      confirmPassword: 'Confirm Password',
      lastReport: 'Last Report',
      repeat: 'Repeat',
      recipients: 'Recipients',
      dayOfTheWeek: 'Days Of The Week',
      dayOfTheMonth: 'Day Of The Month',
      selectDefault: 'Select one below',
      headersAndPayload: 'Headers & Payload',
      method: 'Method',
      url: 'URL',
      apiChannels: 'API Channels',
      headers: 'Headers',
      payload: 'Payload',
      enterJSONPayload: 'Enter JSON payload',
      enterValidJSONPayload: 'Enter a valid JSON payload',
      tickets: 'Tickets',
      apiChannel: {
        httpConfig: 'HTTP Configuration',
        sendCondition: 'Send Condition',
        payloadMapping: 'Payload Mapping',
        payloadPreview: 'JSON Preview',
        queryFilter: 'Query Filter',
        queryPlaceholder: 'e.g., severity:high AND source:firewall',
        queryHelp: 'Enter a query to filter logs. Use * to match all.',
        testQuery: 'Test Query',
        logsFound: 'Found {total} logs. Showing 5 most recent:',
        logPreview: 'Log Preview',
        queryError: 'Query Error',
        scheduleHelp: 'How often to run this channel',
        schedule30s: '30 seconds',
        schedule1m: '1 minute',
        schedule5m: '5 minutes',
        schedule15m: '15 minutes',
        schedule30m: '30 minutes',
        schedule1h: '1 hour',
        schedule6h: '6 hours',
        schedule12h: '12 hours',
        schedule24h: '24 hours',
        seconds: 'seconds',
        minute: 'minute',
        minutes: 'minutes',
        hour: 'hour',
        hours: 'hours',
        mapping: 'Mapping',
        constant: 'Constant',
        selectField: 'Select field',
        addField: 'Add Field',
        errorKeyEmpty: 'Key cannot be empty',
        errorDuplicateKey: 'Duplicate key: {key}',
        errorSourceFieldRequired: 'Source field is required for key: {key}',
        stepBasicInfo: 'Basic Info',
        tabConfig: 'Configuration',
        tabPayload: 'Payload Mapping',
        responseIndex: 'Response Index',
        noResponseIndex: 'Do not save response',
        responseIndexHelp: 'Select an index to save API response. Leave empty to skip saving.'
      },
      playbook: 'Playbook',
      slaTitle: 'Resolution within SLA',
      resTime: 'Average Response Time',
      param: 'Param',
      default: 'Default',
      logType: 'Log Type',
      sendNewLogsOnly: 'Send New Logs Only',
      sendBothOldAndNewLogs: 'Send All Logs (Existing and New)',
      notSet: 'Not Specified',
      editLog: 'Edit Input Log',
      log: 'log',
      newPlaybook: 'New Playbook',
      newDashboard: 'New Dashboard',
      newWidget: 'New Widget',
      // System Widget translations
      serverStatus: 'Server Status',
      systemInfo: 'System Info',
      diskUsage: 'Disk Usage',
      cpuUsage: 'CPU Usage',
      ramUsage: 'RAM Usage',
      available: 'available',
      lastUpdated: 'Last Updated',
      autoRefreshIn: 'Auto refresh in',
      errorFetchingMetrics: 'Failed to fetch metrics',
      retry: 'Retry',
      showSystemInfo: 'Show System Info',
      hideSystemInfo: 'Hide System Info',
      // Log Rate Stats translations
      logCount: 'Log Count',
      logSize: 'Log Size',
      logRateStats: 'Log Rate Statistics',
      perSecond: '/sec',
      perMinute: '/min',
      perHour: '/hour',
      perDay: '/day',
      per7Day: '/7 days',
      per30Day: '/30 days',
      dailyQuota: 'Daily Quota',
      quotaWarning: 'Warning: Quota nearly exhausted! Logs will be dropped.',
      droppedLogs: 'Dropped Logs',
      droppedLogsReason: 'Logs dropped due to quota limit or buffer overflow',
      editQuota: 'Edit Quota',
      maxQuotaGB: 'Max Quota (GB)',
      enterQuota: 'Enter quota (GB)',
      currentValue: 'Current value',
      quotaMustBePositive: 'Must be greater than 0',
      quotaUpdated: 'Quota has been updated',
      quotaUpdateFailed: 'Failed to update quota',
      confirmQuotaChange: 'Confirm Quota Change',
      confirmQuotaMessage: 'Are you sure you want to change quota to',
      errorFetchingLogRate: 'Failed to fetch log rate stats',
      // Auto Update translations
      autoUpdate: {
        title: 'Auto Update',
        enabled: 'Enabled',
        state: 'State',
        interval: 'Check Interval',
        lastRun: 'Last Run',
        lastStatus: 'Last Status',
        lastError: 'Last Error',
        updatedAt: 'Updated At',
        updated: 'Auto-update settings updated',
        updateFailed: 'Failed to update auto-update settings',
        blockedHint: 'Update failed. Toggle OFF then ON to retry.'
      },
      // Log Volume Chart translations
      dailyLogVolume: 'Daily Log Volume',
      logVolumeLabel: 'Volume (GB)',
      newIncident: 'New Incident',
      newTicket: 'New Ticket',
      newAlert: 'New Alert',
      newAction: 'New Action',
      newSourceType: 'New Source Type',
      newDataInput: 'New Data Input',
      newIndex: 'New Index',
      newMapping: 'New Mapping',
      mappings: 'Mappings',
      noMappings: 'No mappings defined',
      fieldName: 'Field Name',
      alias: 'Alias',
      editAlias: 'Edit Alias',
      fieldAlreadyExists: 'Field already exists',
      newForwarder: 'New Forwarder',
      newReport: 'New Report',
      newUser: 'New User',
      changePassword: 'Change Password',
      newAPIChannel: 'New API Channel',
      countLogSend: 'Logs Sent',
      newExportJob: 'New Export Job',
      editExportJob: 'Edit Export Job',
      none: 'None',
      notAvailable: 'N/A',
      online: 'Online',

      // Import Log
      uploadFile: 'Upload File',
      selectFile: 'Select File',
      chooseFile: 'Choose File',
      dragDropFile: 'or drag and drop file here',
      fileName: 'File Name',
      fileSize: 'File Size',
      uploadProgress: 'Upload Progress',
      uploadSpeed: 'Upload Speed',
      timeRemaining: 'Time Remaining',
      cancelUpload: 'Cancel Upload',
      uploadComplete: 'Upload Complete',
      uploadFailed: 'Upload Failed',
      uploadCanceled: 'Upload Canceled',
      uploading: 'Uploading',
      processing: 'Processing',
      validating: 'Validating',
      fileTooLarge: 'File is too large',
      invalidFileType: 'Invalid file type',
      supportedFormats: 'Supported formats',
      maxFileSize: 'Maximum file size',
      retryUpload: 'Retry Upload',
      validFile: 'Valid File',
      invalidFile: 'Invalid File',
      fileEmpty: 'File is empty or invalid',
      invalidFileName: 'Invalid filename. Cannot contain path separators',
      fileNameTooLong: 'Filename is too long (maximum 255 characters)',
      fileNameEmpty: 'Filename cannot be empty',
      uploadHistory: 'Upload History',
      progress: 'Progress',
      download: 'Download',
      confirmDelete: 'Are you sure you want to delete this item?',
      deleteSuccess: 'Item deleted successfully',
      deleteError: 'Failed to delete item',
      downloadError: 'Failed to download file',
      offline: 'Offline',
      version: 'Version',
      yes: 'Yes',
      no: 'No',
      complete: 'Complete',
      all: 'All',
      saveAs: 'Save As',
      dashboardWidget: 'Dashboard Widget',
      reportWidget: 'Report Widget',
      alert: 'Alert',
      warning: 'Warning',
      savingTheQuery: 'Saving The Query',
      dashboard: 'Dashboard',

      // Additional upload translations
      upload: 'Upload',
      selectFileToUpload: 'Select File to Upload',
      fileSelected: 'File Selected',
      readyToUpload: 'Ready to upload',
      startUpload: 'Start Upload',
      selectIndexAndSourceType: 'Please select index and source type',
      uploadCompleted: 'Upload completed successfully',
      noUploadPermission: 'You do not have permission to upload files',
      taskDeletedSuccessfully: 'Task deleted successfully',
      sessionRemovedSuccessfully: 'Session removed successfully',
      failedToRemoveSession: 'Failed to remove session',
      paused: 'Paused',
      failed: 'Failed',
      completed: 'Completed',
      cancelled: 'Cancelled',
      unknown: 'Unknown',
      status: {
        status: "Status",
        created: 'Created',
        uploading: 'Uploading',
        queued: 'Queued',
        processing: 'Processing',
        completed: 'Completed',
        canceled: 'Canceled',
        failed: 'Failed'
      },
      errorNoWidgets: 'The page is empty',
      errorWidgetsCustomizing: 'Please save or cancel the customizing first',
      pageOf: 'Page {0}/{1}',
      startTime: 'Start Time',
      endTime: 'End Time',
      enterQuery: 'Enter search query',
      id: 'ID',
      code: 'Code',
      exportJob: {
        status: {
          pending: 'Pending',
          running: 'Running',
          completed: 'Completed',
          failed: 'Failed',
          canceled: 'Canceled'
        },
        confirmCancel: 'Are you sure you want to cancel this job?',
        downloadError: 'Failed to download export file'
      },

      route: {
        dashboards: 'Dashboards',
        search: 'Search',
        advancedSearch: 'Advanced Search',
        alerts: 'Alerts',
        reports: 'Reports',
        incidents: 'Incidents',
        tickets: 'Tickets',
        actions: 'Actions',
        playBooks: 'Playbooks',
        indexes: 'Indexes',
        sourceTypes: 'Source Types',
        dataInputs: 'Data Inputs',
        mappings: 'Mappings',
        users: 'Users',
        Settings: 'Settings',
        forwarders: 'Forwarders',
        apiChannels: 'API Channels',
        parser: 'Log Parser',
        exportJobs: 'Export Jobs',
        importLog: 'Import Log',
        copyright: 'Copyright',
        server: 'Server'
      },
      subtitle: {
        search: 'Events querying and Visualization',
        advancedSearch: 'Search using Elasticsearch DSL JSON queries',
        alerts: 'Monitoring based on metric values',
        incidents: 'Incident response management',
        tickets: 'Tickets management',
        actions: 'Actions management',
        playBooks: 'Playbooks management',
        indexes: 'Search engine index management',
        reports: 'Summary reports on system security',
        sourceTypes: 'Type definitions for sources',
        dataInputs: 'Source Management',
        mappings: 'Elasticsearch field mappings management',
        users: 'Users management & authorization',
        forwarders: 'Logs forwarding & resource monitoring',
        apiChannels: 'API channels management',
        parser: 'Log Parser Constructor',
        exportJobs: 'Export jobs management and monitoring',
        importLog: 'Import and process log files for analysis',
        copyright: 'License information',
        server: 'Server status and system metrics'
      },
      copyright: {
        sectionTitle: 'Copyright',
        company: 'Company',
        copyrightOwner: 'Copyright Owner',
        product: 'Product',
        licenseCode: 'License Code',
        softwareVersion: 'Software Version',
        activationDate: 'Activation Date',
        expirationDate: 'Expiration Date',
        updateLicense: 'Update License',
        updateLicenseInfo: 'To use a different license code, please select "Update License" below. If you do not have a license code, please contact the hotline {phone} or email {email}.',
        contactInfo: 'In case you do not have a license code, please contact hotline {phone} or email {email}.'
      },
      chart: {
        type: 'Chart Type',
        pie: 'Pie Chart',
        line: 'Line Chart',
        bar: 'Bar Chart',
        error: 'Please try again later',
        errorNoData: 'No Data Available Or Invalid Type'
      },
      search: {
        result: 'Total {total} events from {start} to {end}',
        errorNoCharts: 'The output cannot be visualized. Please use aggregations.',
        errorNoEvents: 'There are no events within the period. Please change your query or choose another time range.',
        loading: 'Loading',
        query: 'Query',
        events: 'Events',
        visualization: 'Visualization',
        queryValidation: 'Query Validation:',
        queryValidationMessage: 'Please ensure your JSON query is valid before submitting.',
        expandValue: 'Show full',
        collapseValue: 'Show less'
      },
      report: {
        daily: 'Daily Report',
        weekly: 'Weekly Report',
        monthly: 'Monthly Report'
      },
      // DataTable component
      datatable: {
        search: 'Search...',
        itemsPerPage: 'Items per page',
        showing: 'Showing {start} - {end} of {total} records',
        noData: 'No data available',
        noResults: 'No results found',
        page: 'Page',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        sortAscending: 'Sort ascending',
        sortDescending: 'Sort descending'
      },

      users: {
        errorPasswordNotMatch: 'The confirm password does not match the new password',
        addUser: 'Add User',
        updateUser: 'Update user - {username}',
        searchPlaceholder: 'Search with name, email',
        serialNumber: 'STT',
        username: 'Username',
        confirmPassword: 'Confirm Password',
        permissions: 'Permissions',
        role: 'Role',
        status: 'Status',
        createdTime: 'Created Time',
        actions: 'Actions',
        update: 'Update',
        resetPassword: 'Reset Password',
        activate: 'Activate',
        deactivate: 'Deactivate',
        forceLogout: 'Force Logout',
        selectPermission: 'Select Permission',
        currentStatus: 'Current Status',
        confirmResetPassword: 'Are you sure you want to reset the password for user "{name}"?',
        confirmToggleStatus: 'Are you sure you want to {action} user "{name}"?',
        passwordResetSuccess: 'Password has been reset successfully',
        passwordResetError: 'An error occurred while resetting the password',
        passwordChangeSuccess: 'Password has been changed successfully',
        passwordChangeError: 'An error occurred while changing the password',
        oldPasswordIncorrect: 'The old password is not correct',
        newPasswordSameAsOld: 'The new password must be different from the old password',
        userStatusUpdateSuccess: 'User has been {action} successfully',
        userStatusUpdateError: 'An error occurred while {action} the user',
        userCreateError: 'An error occurred while creating the user',
        userUpdateError: 'An error occurred while updating the user',
        forceLogoutConfirmTitle: 'Force Logout User',
        forceLogoutConfirmMessage: 'Are you sure you want to force logout user "{username}"?',
        forceLogoutWarning: 'This will immediately terminate all active sessions for this user.',
        forceLogoutConfirmButton: 'Force Logout',
        forceLogoutCancelButton: 'Cancel',
        forceLogoutSuccess: 'User "{name}" has been force logged out successfully',
        forceLogoutError: 'An error occurred while force logging out user "{name}"',
        statusActive: 'Active',
        statusInactive: 'Inactive',
        newPassword: 'New Password',
        enterNewPassword: 'Enter new password',
        enterOldPassword: 'Enter old password',
        generateRandomPassword: 'Generate Random Password',
        copyPassword: 'Copy Password',
        passwordGenerated: 'Password generated successfully',
        passwordCopiedSuccess: 'Password copied to clipboard successfully',
        passwordCopyError: 'Failed to copy password to clipboard',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
        itemsPerPage: 'Items per page',
        roles: {
          root: 'Root',
          admin: 'Admin',
          user: 'User',
          monitor: 'Monitor'
        },
        filter: {
          title: 'Filter',
          roles: 'Roles',
          status: 'Status',
          confirm: 'Confirm',
          clearAll: 'Clear all filters',
          active: 'Active',
          inactive: 'Inactive',
          resultCount: '{count} users found'
        },
        tooltips: {
          username: 'Username must be 3-30 characters long, contain only letters, numbers, and underscores, and be unique in the system.',
          email: 'Email must be a valid format, unique in the system, and less than 1000 characters.',
          password: 'Password must be 8-60 characters long, contain ASCII characters only (no Vietnamese), include at least one uppercase letter, one lowercase letter, one number, and one special character.',
          confirmPassword: 'Confirm password must match the password entered above.'
        },
        placeholders: {
          username: 'Enter username',
          email: 'Enter email',
          password: 'Enter password',
          confirmPassword: 'Enter confirm password'
        },
        validation: {
          emailRequired: 'Email is required',
          emailInvalid: 'Please enter a valid email address',
          emailTooLong: 'Email cannot exceed 1000 characters',
          emailExists: 'This email address is already in use',
          usernameRequired: 'Username is required',
          usernameTooShort: 'Username must be at least 3 characters long',
          usernameTooLong: 'Username cannot exceed 30 characters',
          usernameNoSpaces: 'Username cannot contain spaces',
          usernameInvalidChars: 'Username is invalid',
          usernameExists: 'This username is already taken',
          oldPasswordRequired: 'Please enter your old password',
          passwordRequired: 'Password is required',
          passwordTooShort: 'Password must be at least 8 characters long',
          passwordTooLong: 'Password must be no more than 60 characters long',
          passwordAsciiOnly: 'Password must contain only ASCII characters (no Vietnamese characters)',
          passwordNeedsUppercase: 'Password must contain at least one uppercase letter',
          passwordNeedsLowercase: 'Password must contain at least one lowercase letter',
          passwordNeedsNumber: 'Password must contain at least one number',
          passwordNeedsSpecialChar: 'Password must contain at least one special character',
          confirmPasswordRequired: 'Confirm password is required',
          passwordsDoNotMatch: 'Passwords do not match',
          formHasErrors: 'Please fix the validation errors before submitting'
        },
        passwordRequirements: 'Password must be at least 8 characters with uppercase, lowercase, and number'
      },
      sourceTypes: {
        name: "Name",
        searchPlaceholder: 'Search by Source Type Name, Description, Type',
        format: 'Format',
        filter: {
          title: 'Format',
          confirm: 'Confirm',
          clearAll: 'Clear all filters',
          custom: 'custom'
        },
        form: {
          name: 'Source Type Name',
          nameTooltip: 'Name must be 3-30 characters, only letters, numbers, hyphens, underscores, and dots allowed',
          namePlaceholder: 'Enter source type name',
          description: 'Description',
          descriptionPlaceholder: 'Enter description',
          format: 'Format',
          eventSeparator: 'Event Separator',
          eventSeparatorTooltip: 'Fill in content to distinguish between events',
          eventSeparatorPlaceholder: 'Enter event separator',
          comment: 'Comment',
          commentTooltip: 'Content after this character will be ignored and not analyzed',
          commentPlaceholder: 'Enter comment character',
          timestampMode: 'Log Receive Time',
          autoTimestamp: 'Auto-fill with system time (Default)',
          manualTimestamp: 'Use timestamp field',
          timestampField: 'Field Name',
          timestampFieldPlaceholder: 'Enter field name',
          timestampFormat: 'Format',
          timestampFormatPlaceholder: 'Enter format',
          fieldsList: 'Fields List',
          fieldNamePlaceholder: 'Enter field name',
          addField: 'Add',
          fieldsRequired: 'At least one field is required',
          fieldSeparator: 'Field Separator',
          fieldSeparatorTooltip: 'Fill in content to distinguish between fields',
          fieldSeparatorPlaceholder: 'Enter field separator',
          regexp: 'RegEx',
          regexpPlaceholder: 'Enter regular expression',
          cancel: 'Cancel',
          confirm: 'Confirm'
        },
        validation: {
          nameRequired: 'Source type name is required',
          nameTooShort: 'Source type name must be at least 3 characters long',
          nameTooLong: 'Source type name cannot exceed 30 characters',
          nameInvalidChars: 'Source type name can only contain letters, numbers, hyphens, underscores, and dots',
          nameExists: 'A source type with this name already exists',
          eventSeparatorRequired: 'Event separator is required',
          eventSeparatorNoSpaces: 'Event separator cannot contain spaces',
          fieldSeparatorRequired: 'Field separator is required',
          fieldSeparatorNoSpaces: 'Field separator cannot contain spaces',
          commentNoSpaces: 'Comment cannot contain spaces',
          regexpRequired: 'RegEx is required',
          fieldsRequired: 'At least one field is required',
          fieldNameRequired: 'Please enter field name',
          fieldNameNoSpaces: 'Field name cannot contain spaces',
          timeFieldRequired: 'Field name is required',
          timeFieldNoSpaces: 'Time field name cannot contain spaces',
          timeFormatRequired: 'Format is required'
        },
        messages: {
          createSuccess: 'Source type created successfully',
          updateSuccess: 'Source type updated successfully',
          createError: 'Failed to create source type',
          updateError: 'Failed to update source type',
          deleteSuccess: 'Source type deleted successfully',
          deleteError: 'Failed to delete source type'
        },
        updateTitle: 'Update Source Type - {name}',
        deleteConfirmation: {
          title: 'Confirm Delete Source Type',
          warningTitle: 'Source Type Deletion Warning',
          message: 'Are you sure you want to delete source type "{name}"?',
          warning: 'This action cannot be undone.',
          countdown: 'Please wait {seconds} seconds before you can delete...',
          confirm: 'Confirm',
          cancel: 'Cancel',
          dependencyWarning: 'Cannot delete this source type because it is being used in:',
          dataInputLabel: 'Data Inputs',
          forwarderLabel: 'Forwarders'
        },
        wizard: {
          button: 'Smart Detection',
          title: 'Source Type Wizard',
          createTitle: 'Create Source Type',
          editTitle: 'Edit Source Type',
          step: 'Step {current} of {total}',
          previous: 'Previous',
          next: 'Next',
          create: 'Create',
          update: 'Update',
          fieldMapping: 'Field Mapping',
          preview: 'Preview',
          finalConfig: 'Final Configuration',
          steps: {
            paste: 'Paste Logs',
            detect: 'Detection',
            mapping: 'Field Mapping',
            preview: 'Preview',
            save: 'Save'
          },
          paste: {
            title: 'Paste Sample Logs',
            description: 'Paste one or more sample log lines to auto-detect the format',
            placeholder: 'Paste your log samples here...\nEach line will be analyzed separately.',
            detectButton: 'Detect Format',
            clearButton: 'Clear'
          },
          detect: {
            title: 'Detection Results',
            description: 'Select the best matching format for your logs',
            noResults: 'No format detected. Please check your log samples.',
            confidence: 'Confidence',
            selectButton: 'Select'
          },
          mapping: {
            title: 'Field Mapping',
            description: 'Optionally configure field renaming and type casting',
            skipButton: 'Skip',
            tabs: {
              rename: 'Rename Fields',
              typeCast: 'Type Cast',
              positional: 'Positional (CSV)',
              extract: 'Extract'
            },
            rename: {
              from: 'Original Name',
              to: 'New Name',
              add: 'Add Rename'
            },
            typeCast: {
              field: 'Field',
              type: 'Type',
              add: 'Add Type Cast'
            },
            positional: {
              index: 'Index',
              name: 'Field Name',
              type: 'Type',
              add: 'Add Field'
            },
            extract: {
              source: 'Source Field',
              pattern: 'Regex Pattern',
              target: 'Target Field',
              add: 'Add Extract'
            }
          },
          parsePreview: {
            title: 'Parse Preview',
            description: 'Review how your logs will be parsed',
            rawLog: 'Raw Log',
            parsedResult: 'Parsed Result',
            refreshButton: 'Refresh',
            success: 'Parse successful',
            error: 'Parse failed'
          },
          save: {
            title: 'Save Source Type',
            description: 'Enter a name for your new source type',
            nameLabel: 'Name',
            namePlaceholder: 'e.g., FortiGate Firewall',
            descriptionLabel: 'Description',
            descriptionPlaceholder: 'Optional description...'
          },
          buttons: {
            back: 'Back',
            next: 'Next',
            skip: 'Skip',
            save: 'Save',
            cancel: 'Cancel'
          },
          messages: {
            detectSuccess: 'Format detected successfully',
            detectFailed: 'Failed to detect format',
            previewSuccess: 'Preview updated',
            previewFailed: 'Preview failed',
            saveSuccess: 'Source type created successfully',
            saveFailed: 'Failed to create source type'
          },
          tiers: {
            tier0: 'Raw (No Parse)',
            tier1: 'Known Format',
            tier2: 'Delimiter-based',
            tier3: 'Template',
            tier4: 'Regex'
          },
          parserTypes: {
            json: 'JSON',
            xml: 'XML',
            cef: 'CEF',
            syslog_kv: 'Key-Value',
            syslog_csv: 'CSV',
            dissect: 'Dissect Pattern',
            drain: 'Auto Template',
            regex: 'Regular Expression'
          },
          createTitle: 'Create New Source Type',
          editTitle: 'Edit Source Type',
          logSample: 'Log Sample',
          logSamplePlaceholder: 'Paste your log samples here...\nEach line will be analyzed separately.',
          logSampleTooltip: 'Paste one or more log lines to auto-detect the format',
          detectFormat: 'Detect Format',
          fieldMapping: 'Field Mapping',
          fieldMappingDescription: 'Configure how fields are mapped from source to target',
          fieldMappings: 'Field Mappings',
          noFieldMappings: 'No field mappings configured',
          fieldMappingOptional: 'Field mapping is optional. Click Next to continue.',
          parsedFields: 'Detected Fields',
          addMapping: 'Add Mapping',
          enterSourceField: 'Enter source field name',
          enterTargetField: 'Enter target field name',
          csvMappingDescription: 'Map CSV column positions to field names. Leave empty to skip a field.',
          kvMappingDescription: 'Map parsed key-value fields to custom names. Leave empty to keep original name.',
          parsedField: 'Parsed Field',
          mappedName: 'Mapped Name',
          position: 'Position',
          sampleValue: 'Sample Value',
          fieldName: 'Field Name',
          loadingFields: 'Loading fields...',
          noFieldsDetected: 'No fields detected',
          loadFieldsError: 'Failed to load field preview',
          configSummary: 'Configuration Summary',
          parserType: 'Parser Type',
          tier: 'Tier',
          noSuggestionSelected: 'Please select a detection suggestion',
          sourceField: 'Source Field',
          targetField: 'Target Field',
          back: 'Back',
          next: 'Next',
          skip: 'Skip',
          cancelConfirmTitle: 'Discard Changes?',
          cancelConfirmMessage: 'You have unsaved changes. Are you sure you want to discard them?',
          continueEditing: 'Continue Editing',
          discardChanges: 'Discard Changes'
        },
        detection: {
          analyzing: 'Analyzing log format...',
          confidence: 'Confidence',
          noSuggestions: 'No format detected',
          noSuggestionsHint: 'Try pasting different log samples',
          detectError: 'Failed to detect format'
        },
        parsePreview: {
          rawLog: 'Raw Log',
          parsedResult: 'Parsed Result',
          success: 'Parse successful',
          failed: 'Parse failed',
          refresh: 'Refresh',
          showJson: 'Show JSON',
          hideJson: 'Hide JSON',
          field: 'Field',
          value: 'Value',
          noRawLog: 'No raw log provided',
          noResult: 'No parse result',
          parseError: 'Parse error',
          previewError: 'Preview error'
        },
        fieldMapping: {
          rename: 'Rename',
          typeCast: 'Type Cast',
          positional: 'Positional',
          extract: 'Extract',
          oldFieldName: 'Original Field Name',
          newFieldName: 'New Field Name',
          fieldName: 'Field Name',
          index: 'Index',
          regexPattern: 'Regex Pattern',
          sourceField: 'Source Field',
          targetField: 'Target Field',
          selectField: 'Select field...'
        },
        eventDelimiter: 'Event Delimiter',
        comment: 'Comment',
        placeholders: {
          eventDelimiter: 'Enter event delimiter (e.g., \\n)',
          comment: 'Enter comment prefix (e.g., #)'
        },
        tooltips: {
          eventDelimiter: 'Character(s) that separate log events. Default is newline (\\n).'
        },
        parserv2: {
          selectParserAndLog: 'Select Parser Type and Input Log',
          selectParserAndLogDescription: 'Choose a parser type and provide a sample log for parsing',
          parserType: 'Parser Type',
          loadingParsers: 'Loading parsers...',
          selectParserPlaceholder: 'Select a parser type',
          sampleLog: 'Sample Log',
          logPlaceholder: 'Paste your sample log here...',
          fieldMappingDescription: 'Map parsed fields to custom field names (optional)',
          previewDescription: 'Review the parser configuration before saving',
          finalConfigDescription: 'Enter basic information to complete',
          sourceField: 'Source Field',
          sampleValue: 'Sample Value',
          targetField: 'Target Field',
          noFieldsParsed: 'No fields were parsed from the log',
          namePlaceholder: 'Enter source type name',
          descriptionPlaceholder: 'Enter description (optional)',
          fieldsDetected: 'Fields Detected',
          fieldsMapped: 'Fields Mapped',
          mappingsSummary: 'Field Mappings Summary',
          noMappings: 'No field mappings configured',
          parseError: 'Failed to parse log',
          loadParsersError: 'Failed to load available parsers'
        }
      },
      logout: {
        confirmTitle: 'Confirm Logout',
        confirmMessage: 'Are you sure you want to logout?',
        confirmButton: 'Ok',
        cancelButton: 'Cancel'
      },
      teible: {
        showing: 'Show',
        total: 'total {count} record',
        last: 'last record',
        empty: 'no data',
        filter: 'Search...'
      },
      forwarderDisabledMessage: 'Settings are hidden because the forwarder is disabled. Enable the forwarder to view and edit settings.',
      forwarders: {
        searchPlaceholder: 'Search by Forwarder Name, Description',
        loadError: 'Failed to load forwarders',
        downloadAgent: 'Download Agent',
        uploadNewVersion: 'Upload New Version',
        chooseFile: 'Choose file',
        dragDropFile: 'or drag and drop file attachment',
        uploadSuccess: 'File uploaded successfully',
        systemLog: 'System Log',
        resourceMonitor: 'Resource Monitor',
        fileLog: 'File Log',
        enableWindows: 'Enable Windows',
        enableLinux: 'Enable Linux',
        windowsX64: 'Windows x64',
        windowsX32: 'Windows x32',
        linuxX64: 'Linux x64',
        linuxX32: 'Linux x32',
        inputText: 'Input Text',
        fileFormatInfo: '.ZIP format | Maximum size: 100MB',
        agents: 'Agents',
        agentsSubtitle: 'The list of agents installed',
        hostname: 'Hostname',
        macAddress: 'MAC Address',
        ips: 'IPs',
        noIPs: 'No IPs',
        lastSeen: 'Last seen',
        releasedVersions: 'Released versions',
        releaseDate: 'Release Date',
        os: 'OS',
        architecture: 'Architecture',
        stable: 'Stable',
        editVersion: 'Edit Version',
        stableVersion: 'Stable Version',
        stableVersionHelp: 'Stable versions cannot be changed back to unstable.',
        pleaseUploadAtLeastOneFile: 'Please upload at least one file',
        cannotUploadNewVersion: 'Cannot upload new version',
        versionUpdatedSuccessfully: 'Version updated successfully',
        failedToUpdateVersion: 'Failed to update version',
        failedToDownloadAgent: 'Failed to download agent setup file',
        description: 'Description',
        fileFormat: 'Format .ZIP | Maximum size: 100MB',
        cancel: 'Cancel',
        complete: 'Complete',
        uploadNewVersionBtn: 'Upload a new version',
        pleaseUploadFile: 'Please upload at least one file',
        uploadError: 'Unable to upload new version',
        selectIndex: 'Select index',
        selectSourceType: 'Select source type',
        selectChannel: 'Select channel',
        sourceType: 'Source Type',
        noSuitableSourceType: 'No suitable source type',
        logSendInterval: 'Log Send Interval (seconds)',
        batchSize: 'Batch Size',
        checkInterval: 'Check Interval (seconds)',
        metrics: 'Metrics',
        channels: 'Channels',
        customPaths: 'Custom Paths',
        paths: 'Paths',
        excludes: 'Excludes',
        stream: 'Stream',
        streamName: 'Stream Name',
        addStream: 'Add stream',
        removeStream: 'Remove this stream',
        noStreamsAdded: 'No streams have been added yet.',
        enterLogPath: 'Enter log file path',
        enterExcludePattern: 'Enter exclude pattern (optional)',
        version: 'Version',
        stableVersionNote: 'Stable versions cannot be changed back to unstable.',
        yes: 'Yes',
        no: 'No',
        none: 'None',
        online: 'Online',
        offline: 'Offline',
        deleteAgentConfirm: 'Delete agent "{name}"?',
        deleteAgentWarning: 'This action cannot be undone.',
        downloadAgentError: 'Failed to download agent setup file',
        noStreams: 'No streams added yet',
        basicInfo: 'Basic Information',
        currentStep: 'Current Step',
        back: 'Back',
        continue: 'Continue',
        confirm: 'Confirm',
        forwarderName: 'Forwarder Name',
        forwarderType: 'Forwarder Type',
        enterForwarderName: 'Enter forwarder name',
        enterDescription: 'Enter description',
        nameRules: 'Name Rules',
        nameRuleNotEmpty: 'Cannot be empty',
        nameRuleNotDuplicate: 'Cannot be duplicate',
        nameRuleNoSpace: 'No spaces or special characters allowed (except dash "-", underscore "_", and dot ".")',
        nameRuleLength: 'Length: minimum 3, maximum 30 characters',
        tokenHelp: 'Token is used as connection identifier from CyEDR to CySIEM',
        regenerateToken: 'Regenerate token',
        copyToken: 'Copy token',
        tokenCopied: 'Token copied to clipboard',
        selectAtLeastOneModule: 'Please select at least one module',
        moduleNotSelected: 'This module is not selected',
        sendLogConfig: 'Send Log Configuration',
        timeInterval: 'Time Interval',
        timeIntervalHelp: 'Time interval between log sends (seconds)',
        timeIntervalUnit: 'Unit: seconds',
        enterTimeInterval: 'Enter time interval',
        logCount: 'Log Count',
        logCountHelp: 'Number of logs to send per batch',
        enterLogCount: 'Enter log count',
        channel: 'Channel',
        channelHelp: 'Select channels to monitor',
        enterChannelPath: 'Enter channel path and press Enter',
        customPath: 'Custom Path',
        customPathHelp: 'Enter custom paths',
        enterCustomPath: 'Enter custom paths',
        noIndexAvailable: 'No index available',
        noSourceTypeAvailable: 'No source type available',
        noChannelAvailable: 'No channel available',
        checkIntervalHelp: 'Interval to check resource metrics (seconds)',
        checkIntervalUnit: 'Unit: seconds',
        enterCheckInterval: 'Enter check interval',
        metricsHelp: 'Select metrics to monitor',
        metricCPU: 'CPU',
        metricRAM: 'RAM',
        metricDisk: 'Disk',
        metricNetwork: 'Network',
        fileStreams: 'File Streams',
        noStreamsConfigured: 'No streams configured yet',
        filePath: 'File Path',
        filePaths: 'File Paths',
        enterFilePath: 'Enter file path',
        enterFilePaths: 'Type path and press Enter',
        filePathsHelp: 'Type each path and press Enter',
        excludePaths: 'Exclude Paths',
        enterExcludePaths: 'Type path and press Enter',
        excludePathsHelp: 'Type each path to exclude and press Enter',
        enterStreamName: 'Enter stream name',
        cancelCreateTitle: 'Cancel Create Forwarder',
        cancelCreateMessage: 'Are you sure you want to cancel creating this forwarder?',
        addForwarderSuccess: 'Forwarder created successfully!',
        addForwarderFailed: 'Failed to create forwarder',
        pleaseCompleteAllRequiredFields: 'Please complete all required fields',
        pleaseEnterForwarderName: 'Please enter forwarder name',
        nameTooShort: 'Forwarder name is not correct',
        nameTooLong: 'Forwarder name cannot exceed 30 characters',
        nameInvalidCharacters: 'Forwarder name is not correct',
        nameExists: 'Forwarder name already exists',
        forwarderNameInvalid: 'Forwarder name is invalid',
        pleaseSelectAtLeastOneModule: 'Please select at least one module',
        pleaseConfigureSystemLog: 'Please configure system log settings',
        pleaseConfigureResourceMonitor: 'Please configure resource monitor settings',
        pleaseConfigureFileLog: 'Please configure file log settings',
        pleaseCompleteBasicInfoFirst: 'Please complete basic information first',
        intervalRangeError: 'Time interval must be between 3 and 86400 seconds',
        timeIntervalRules: 'Time Interval Rules',
        timeIntervalRuleMin: 'Minimum value: 3 seconds',
        timeIntervalRuleMax: 'Maximum value: 86400 seconds',
        logCountRules: 'Log Count Rules',
        logCountRuleMin: 'Minimum value: 1',
        logCountRuleMax: 'Maximum value: 999999',
        checkIntervalRules: 'Check Interval Rules',
        checkIntervalRuleMin: 'Minimum value: 3 seconds',
        checkIntervalRuleMax: 'Maximum value: 86400 seconds',
        checkIntervalRangeError: 'Check interval must be between 3 and 86400 seconds',
        batchSizeRangeError: 'Log count must be between 1 and 999999',
        streamNameMaxLength: 'Max 30 characters',
        streamNameRequired: 'Please enter stream name',
        streamNameInvalid: 'Stream name is not correct',
        streamNameDuplicate: 'Stream name already exists',
        filePathsRequired: 'Please enter file path',
        filePathsTooltip: 'Enter file path to collect logs and press Enter',
        excludePathsTooltip: 'Enter file path to exclude from log collection and press Enter',
        validation: {
          completeExistingStreams: 'Please complete the Index and Source Type configuration for existing streams before adding a new one.'
        }
      },

      indexes: {
        searchPlaceholder: 'Search by Index Name, Description',
        searchHelp: 'Search by Index Name, Description',
        addIndexTitle: 'Add Index',
        editIndexTitle: 'Update Index - {indexName}',
        indexName: 'Index Name',
        indexDescription: 'Description',
        maxSize: 'Max Size',
        maxStorageTime: 'Max Storage Time',
        status: 'Status',
        statusEnabled: 'Enabled',
        statusDisabled: 'Disabled',
        confirmButton: 'Confirm',
        cancelButton: 'Cancel',
        unitDay: 'Day',
        unitDays: 'Days',
        unitHour: 'Hour',
        unitHours: 'Hours',
        noData: 'No data',
        unlimited: 'Unlimited',
        enableIndex: 'Enable index',
        createSuccess: 'Index created successfully',
        updateSuccess: 'Index updated successfully',
        columnLabels: {
          name: 'Index Name',
          size: 'Current Size/Max Size',
          storageDuration: 'Storage Duration/Max Storage Duration',
          createdAt: 'Created Time',
          actions: 'Actions'
        },
        actions: {
          update: 'Update'
        },
        filter: {
          title: 'Advanced Filter',
          statusActive: 'Active',
          statusInactive: 'Inactive',
          confirm: 'Confirm',
          clearAll: 'Clear All Filters'
        },
        validation: {
          nameRequired: 'Index name is required',
          nameTooShort: 'Index name must be at least 3 characters long',
          nameTooLong: 'Index name cannot exceed 30 characters',
          nameInvalidChars: 'Index name can only contain letters, numbers, hyphens, underscores, and dots',
          nameNoUppercase: 'Index name is invalid',
          nameExists: 'An index with this name already exists',
          descriptionTooLong: 'Description cannot exceed {max} characters',
          maxSizeRequired: 'Maximum size is required',
          maxSizeInvalid: 'Maximum size must be a valid number',
          rotateTimeRequired: 'Rotate time is required',
          rotateTimeInvalid: 'Rotate time must be a valid number',
          formHasErrors: 'Please correct the validation errors before submitting'
        },
        tooltips: {
          name: 'Required. 3-30 characters. Only lowercase letters, numbers, hyphens (-), underscores (_), and dots (.) allowed. Uppercase letters are not allowed. Must be unique.',
          description: 'Optional. Maximum 4096 characters.',
          maxSize: 'When the storage capacity reaches the maximum value, the system will delete the oldest storage date.',
          rotateTime: 'When the number of storage days reaches the maximum value, the system will delete the oldest storage day.',
          enabled: 'Enable or disable this index.'
        },
        placeholders: {
          name: 'Enter index name',
          description: 'Enter description',
          maxSize: '10',
          rotateTime: '90'
        },
        deleteConfirmation: {
          title: 'Delete Index - {indexName}',
          warningTitle: 'Index Deletion Warning',
          message: 'Are you sure you want to delete this index?',
          warning: 'Note: This action cannot be undone, please check carefully before confirming!',
          countdown: 'Please wait {seconds} seconds before confirming...',
          confirm: 'Confirm',
          cancel: 'Cancel',
          dependencyWarning: 'Cannot delete this index because it is being used in:',
          dataInputLabel: 'Data Inputs:',
          forwarderLabel: 'Forwarders:'
        },
        deleteSuccess: 'Index deleted successfully!',
        activateSuccess: 'Index activated successfully!',
        deactivateSuccess: 'Index deactivated successfully!',
        statusConfirmation: {
          activateTitle: 'Activate Index - {indexName}',
          deactivateTitle: 'Deactivate Index - {indexName}',
          activateMessage: 'Are you sure you want to activate this index?',
          deactivateMessage: 'Are you sure you want to deactivate this index?',
          confirm: 'Confirm',
          cancel: 'Cancel'
        },
        cancelTitle: 'Confirm Cancel',
        cancelMessage: 'Are you sure you want to cancel? All changes will not be saved.'
      },

      dataInputs: {
        searchPlaceholder: 'Search by name, description',
        messages: {
          createSuccess: 'Data input created successfully',
          updateSuccess: 'Data input updated successfully',
          deleteSuccess: 'Data input deleted successfully',
          activateSuccess: 'Data input activated successfully',
          deactivateSuccess: 'Data input deactivated successfully',
          createError: 'Failed to create data input',
          updateError: 'Failed to update data input',
          deleteError: 'Failed to delete data input',
          activateError: 'Failed to activate data input',
          deactivateError: 'Failed to deactivate data input',
          fetchError: 'Failed to fetch data inputs'
        },
        tooltips: {
          name: 'Data source name must be 3-30 characters long, contain only letters, numbers, hyphens, underscores, and dots, and be unique in the system.',
          description: 'Optional description for the data source. Maximum 4096 characters.',
          tokenCode: 'Code used as connection identifier from CyEDR to CySIEM',
          ssl: 'Enable transmission encryption, only activate when log source has this configuration',
          allowedIPs: 'Enter IPs allowed to send logs to the system, leave empty to allow all IPs',
          port: 'Port number must be between 0 and 65535',
          generateToken: 'Generate new random token',
          copyToken: 'Copy token',
          index: 'Select the index where logs will be stored',
          sourceType: 'Select the source type for log parsing'
        },
        validation: {
          nameRequired: 'Data source name is required',
          nameTooShort: 'Data source name is incorrect.',
          nameTooLong: 'Data source name is incorrect.',
          nameInvalidChars: 'Data source name is incorrect.',
          nameExists: 'A data source with this name already exists',
          descriptionTooLong: 'Description cannot exceed {max} characters',
          portRequired: 'Please enter port number',
          portInvalid: 'Port must be a valid number',
          portOutOfRange: 'Port must be between 0 and 65535',
          portReserved: 'Port 80 and 443 are reserved and cannot be used',
          portExists: 'Port already exists for this protocol',
          ipRequired: 'IP address is required',
          ipTooLong: 'IP address cannot exceed 16 characters',
          ipInvalidFormat: 'Invalid IP address format',
          ipInvalidRange: 'IP address octets must be between 0 and 255',
          ipDuplicate: 'This IP address already exists in the list',
          indexRequired: 'Index is required',
          sourceTypeRequired: 'Source Type is required',
          formInvalid: 'Please fix validation errors before submitting'
        },
        placeholders: {
          name: 'Enter data source name',
          description: 'Enter description for this data source...',
          port: 'Enter port number',
          accessIPs: 'Enter IP and press Enter'
        },
        labels: {
          token: 'Token',
          port: 'Port',
          accessIPs: 'Access IPs'
        },
        deleteConfirmation: {
          title: 'Confirm Delete Data Input',
          message: 'Are you sure you want to delete data input "{name}"?',
          warning: 'This action cannot be undone.',
          countdown: 'Please wait {seconds} seconds before you can delete...',
          confirm: 'Confirm',
          cancel: 'Cancel'
        },
        statusConfirmation: {
          activateTitle: 'Confirm Activate Data Input - {name}',
          deactivateTitle: 'Confirm Deactivate Data Input - {name}',
          activateMessage: 'Are you sure you want to activate this data input?',
          deactivateMessage: 'Are you sure you want to deactivate this data input?',
          confirm: 'Confirm',
          cancel: 'Cancel'
        }
      },
      twoFactor: {
        title: 'Two-Factor Authentication',
        setupTitle: 'Set Up Two-Factor Authentication',
        enterCode: 'Enter the 6-digit code from your authenticator app',
        codePlaceholder: 'Enter code',
        verify: 'Verify',
        enabled: '2FA Enabled Successfully!',
        disabled: '2FA Disabled',
        enable: 'Enable 2FA',
        disable: 'Disable 2FA',
        status: '2FA Status',
        scanQrCode: 'Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)',
        manualEntry: "Can't scan? Enter this code manually:",
        enterCodeToVerify: 'Enter the 6-digit code from your authenticator app to complete setup:',
        saveRecoveryCodes: 'Save these recovery codes in a safe place. You can use them to access your account if you lose your authenticator device.',
        recoveryCodes: 'Recovery Codes',
        regenerateRecoveryCodes: 'Regenerate Recovery Codes',
        useRecoveryCode: 'Use recovery code',
        useAuthenticator: 'Use authenticator code',
        backToLogin: 'Back to login',
        codeRequired: 'Code is required',
        invalidCode: 'Invalid verification code',
        verificationFailed: 'Verification failed',
        passwordRequired: 'Password is required',
        statusEnabled: '2FA is enabled',
        statusDisabled: '2FA is not enabled',
        enabledSince: 'Enabled since',
        disableTitle: 'Disable Two-Factor Authentication',
        disableWarning: 'Disabling 2FA will make your account less secure.',
        verificationCode: 'Verification Code',
        regenerateWarning: 'This will invalidate your existing recovery codes.',
        regenerate: 'Regenerate'
      }
    },
    vi: {
      common: {
        loading: 'Đang tải...',
        done: 'Hoàn tất',
        copy: 'Sao chép',
        copied: 'Đã sao chép',
        download: 'Tải về',
        cancel: 'Hủy',
        close: 'Đóng',
      },
      // Language and theme controls
      language: {
        label: 'Ngôn ngữ',
        select: 'Chọn Ngôn Ngữ'
      },
      theme: {
        label: 'Giao diện',
        select: 'Chọn Giao Diện',
        light: 'Sáng',
        dark: 'Tối'
      },
      authentication: {
        title: 'Xác thực Trang Quản Trị',
        username: 'Tên Đăng Nhập',
        password: 'Mật Khẩu',
        submit: 'Đăng Nhập',
        sessionExpired: 'Phiên đăng nhập của bạn đã hết hạn hoặc đã bị chấm dứt. Vui lòng đăng nhập lại.',
        social: {
          google: 'Đăng nhập với Google',
          microsoft: 'Đăng nhập với Microsoft'
        },
        validation: {
          usernameRequired: 'Tên đăng nhập hoặc email là bắt buộc',
          emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ',
          passwordRequired: 'Vui lòng điền mật khẩu',
          attemptsRemaining: 'lần thử còn lại'
        },
        errors: {
          userNotFound: 'Tên đăng nhập hoặc mật khẩu không đúng',
          wrongPassword: 'Mật khẩu không chính xác',
          accountLocked: 'Tài khoản bị khóa do đăng nhập sai quá nhiều lần',
          accountDeactivated: 'Tài khoản đã bị hủy kích hoạt, liên hệ admin để được hỗ trợ',
          generalError: 'Đã xảy ra lỗi trong quá trình đăng nhập. Vui lòng thử lại.'
        },
        accountLocked: {
          title: 'Tài Khoản Tạm Thời Bị Khóa',
          message: 'Tài khoản của bạn đã tạm thời bị khóa do đăng nhập sai quá nhiều lần.',
          countdownLabel: 'Thời gian còn lại đến khi mở khóa:',
          unlockMessage: 'Bạn có thể thử đăng nhập lại ngay bây giờ.',
          waitMessage: 'Vui lòng đợi đến khi hết thời gian khóa.'
        },
        failedAttempts: {
          title: 'Đăng Nhập Thất Bại',
          message: '{failed} lần thử thất bại. Còn {remaining} lần thử trước khi tài khoản bị khóa.'
        },
        generalError: {
          title: 'Lỗi Đăng Nhập'
        },
        success: 'Đăng nhập thành công'
      },
      copyrightFooter: 'Bản quyền {year} CyRadar. Đã đăng ký bản quyền.',
      markedIncidents: 'Đánh dấu sự cố',
      dontMarkedIncidents: 'Không đánh dấu sự cố',
      actionsList: 'Danh Sách Hàng Động',
      hide: 'Ẩn',
      assign_placeholder: 'Chọn tài khoản để giao',
      forward_placeholder: 'Chọn tài khoản để chuyển tiếp',
      closed_message: 'đã đóng ticket vào lúc',
      pending_message: 'đang xử lý',
      replyTo: 'Phản hồi lại cho',
      replied: 'đã phản hồi',
      at: 'lúc',
      add_note_massage: 'Thêm ghi chú',
      created_ticket_massage: 'đã tạo ticket cho người phụ trách là',
      assigned_to: 'đã giao cho',
      download_message: 'Bấm để tải file đính kèm',
      Unknow: 'Ai đó',
      you: 'Bạn',
      reopen: 'Mở Lại',
      forward: 'Chuyển tiếp',
      addNote: 'Thêm ghi chú',
      reply: 'Phản hồi',
      critical: 'Khẩn Cấp',
      assignedTo: 'Giao Việc Cho',
      total: 'Tổng Số',
      previous: 'Quay Lại',
      next: 'Tiếp Theo',
      incidentsDetail: 'Chi tiết Ứng Phó Sự Cố',
      changeStatus: 'Đổi Trạng Thái',
      infomation: 'Thông Tin',
      high: 'Cao',
      medium: 'Trung Bình',
      low: 'Thấp',
      close: 'Đóng',
      toDo: 'Thực hiện',
      maintainer: 'Người Phụ Trách',
      created: 'Đã Tạo',
      eventsViewer: 'Thông tin sự kiện',
      createdAt: 'Ngày Tạo',
      alertToMaintainer: 'Gửi Cảnh Báo Sau Khi Tạo',
      dontAlertToMaintainer: 'Không Gửi Cảnh Báo Sau Khi Tạo',
      remind: 'Nhắc nhở',
      dontRemind: 'Không Nhắc Nhở',
      deadline: 'Thời hạn',
      remindBeforeDeadline: 'Nhắc nhở trước thời hạn',
      events: 'Sự Kiện',
      incidentsHistogram: 'Lịch sử xử lý sự cố',
      unassigned: 'Chưa Giao',
      overdue: 'Quá Hạn',
      pending: 'Đang Chờ Xử lý',
      closed: 'Đã Đóng',
      priority: 'Ưu Tiên',
      falsePositive: 'Cảnh Báo Nhầm',
      inProcess: 'Đang Xử Lý',
      solved: 'Đã Xử Lý',
      add: 'Thêm',
      save: 'Lưu',
      customize: 'Tùy Chỉnh',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      edit: 'Cập nhật',
      remove: 'Xóa',
      delete: 'Xóa',
      activate: 'Kích hoạt',
      deactivate: 'Hủy kích hoạt',
      stt: 'STT',
      active: 'Đang kích hoạt',
      inactive: 'Không kích hoạt',
      sslEnabled: 'SSL: Bật',
      sslDisabled: 'SSL: Tắt',
      characters: 'ký tự',
      random: 'Ngẫu Nhiên',
      copy: 'Sao Chép',
      query: 'Truy Vấn',
      schedule: 'Đặt Lịch',
      refresh: 'Làm Mới',
      derived: 'Định Nghĩa',
      tickets: 'Vé',
      name: 'Tên',
      title: 'Tiêu Đề',
      description: 'Mô Tả',
      details: 'Chi Tiết',
      enabled: 'Đã Bật',
      disabled: 'Đã Tắt',
      creator: 'Người Tạo',
      lastAlert: 'Cảnh Báo Cuối',
      operator: 'Toán Tử',
      value: 'Giá Trị',
      key: 'Khóa',
      settings: 'Cài Đặt',
      actions: 'Tác Vụ',
      loading: 'Đang Tải...',
      ticketUpdateNotiSuccess: 'Vé đã được làm mới',
      ticketUpdateNoti: 'Vé đã được cập nhật. Nhấn vào biểu tượng để làm mới',
      editWarning: 'Bạn đang sửa một mục khác. Bạn có chắc muốn bỏ qua mục này',
      rus: 'Xác nhận thực hiện?',
      email: 'Email',
      protocol: 'Giao thức',
      port: 'Cổng',
      accessIPs: 'IP Nguồn',
      types: 'Các Kiểu',
      type: 'Kiểu',
      index: 'Chỉ Mục',
      sourceType: 'Kiểu Nguồn',
      token: 'Token',
      delimiter: 'Phân Cách Sự Kiện',
      field_delimiter: 'Phân Cách Trường',
      comment: 'Bình Luận',
      time: 'Thời Gian',
      fields: 'Các Trường',
      field: 'Trường',
      format: 'Định Dạng',
      regexp: 'RegEx',
      autoDetect: 'Tự Động Phát Hiện',
      autoFill: 'Tự Động Điền',
      maxSize: 'Kích Cỡ Tối Đa',
      currentSize: 'Kích Cỡ Hiện Tại',
      size: 'Kích cỡ hiện tại/Kích cỡ tối đa',
      storageDuration: 'Thời gian lưu trữ/Thời gian lưu trữ tối đa',
      unit: 'Đơn Vị',
      modules: 'Mô-đun',
      activeModules: 'Mô-đun Hiện Tại',
      lastEvent: 'Sự Kiện Cuối',
      streams: 'Các Nguồn',
      paths: 'Đường Dẫn',
      excludes: 'Ngoại Trừ',
      intervals: 'Khoảng Thời Gian',
      scopes: 'Quyền',
      password: 'Mật Khẩu',
      oldPassword: 'Mật Khẩu Cũ',
      confirmPassword: 'Nhắc Lại Mật Khẩu',
      lastReport: 'Báo Cáo Cuối',
      repeat: 'Lặp Lại',
      recipients: 'Người Nhận',
      dayOfTheWeek: 'Ngày Trong Tuần',
      dayOfTheMonth: 'Ngày Trong Tháng',
      selectDefault: 'Chọn dưới đây',
      headersAndPayload: 'Headers & Payload',
      method: 'Method',
      url: 'URL',
      sendNewLogsOnly: 'Chỉ gửi log mới',
      sendBothOldAndNewLogs: 'Gửi tất cả log (đã có và mới)',
      notSet: 'Không xác định',
      apiChannels: 'Kênh API',
      param: 'Tên trường',
      default: 'Mặc định',
      logType: 'Kiểu cấu hình',
      editLog: 'Sửa Dữ liệu nhập',
      log: 'Dữ liệu',

      newPlaybook: 'Thêm Kịch Bản Mới',
      newDashboard: 'Thêm Trang',
      // System Widget translations
      serverStatus: 'Trạng Thái Máy Chủ',
      systemInfo: 'Thông Tin Hệ Thống',
      diskUsage: 'Dung Lượng Đĩa',
      cpuUsage: 'Sử Dụng CPU',
      ramUsage: 'Sử Dụng RAM',
      available: 'còn trống',
      lastUpdated: 'Cập Nhật Lần Cuối',
      autoRefreshIn: 'Tự động làm mới sau',
      errorFetchingMetrics: 'Không thể lấy thông số',
      retry: 'Thử Lại',
      showSystemInfo: 'Hiện Thông Tin Hệ Thống',
      hideSystemInfo: 'Ẩn Thông Tin Hệ Thống',
      // Log Rate Stats translations
      logCount: 'Số lượng log',
      logSize: 'Dung lượng log',
      logRateStats: 'Thống kê tốc độ log',
      perSecond: '/giây',
      perMinute: '/phút',
      perHour: '/giờ',
      perDay: '/ngày',
      per7Day: '/7 ngày',
      per30Day: '/30 ngày',
      dailyQuota: 'Quota hàng ngày',
      quotaWarning: 'Cảnh báo: Quota gần hết! Log sẽ bị drop.',
      droppedLogs: 'Log bị drop',
      droppedLogsReason: 'Log bị drop do vượt quota hoặc buffer đầy',
      editQuota: 'Thay đổi Quota',
      maxQuotaGB: 'Quota tối đa (GB)',
      enterQuota: 'Nhập quota (GB)',
      currentValue: 'Giá trị hiện tại',
      quotaMustBePositive: 'Phải lớn hơn 0',
      quotaUpdated: 'Quota đã được cập nhật',
      quotaUpdateFailed: 'Không thể cập nhật quota',
      confirmQuotaChange: 'Xác nhận thay đổi Quota',
      confirmQuotaMessage: 'Bạn có chắc muốn thay đổi quota thành',
      errorFetchingLogRate: 'Không thể lấy thống kê tốc độ log',
      // Auto Update translations
      autoUpdate: {
        title: 'Tự động cập nhật',
        enabled: 'Bật',
        state: 'Trạng thái',
        interval: 'Chu kỳ kiểm tra',
        lastRun: 'Lần chạy cuối',
        lastStatus: 'Kết quả cuối',
        lastError: 'Lỗi cuối',
        updatedAt: 'Cập nhật lúc',
        updated: 'Đã cập nhật cài đặt tự động cập nhật',
        updateFailed: 'Không thể cập nhật cài đặt',
        blockedHint: 'Cập nhật thất bại. Tắt rồi bật lại để thử lại.'
      },
      // Log Volume Chart translations
      dailyLogVolume: 'Dung lượng log hàng ngày',
      logVolumeLabel: 'Dung lượng (GB)',
      newIncident: 'Thêm Ứng Phó Sự Cố',
      newWidget: 'Thêm Thành Phần',
      newAlert: 'Thêm Cảnh Báo',
      newAction: 'Thêm Hành Động',
      newTicket: 'Thêm Vé Mới',
      newSourceType: 'Thêm Kiểu Nguồn',
      newDataInput: 'Thêm Nguồn Dữ Liệu',
      newIndex: 'Thêm Chỉ Mục',
      newMapping: 'Thêm Ánh Xạ',
      mappings: 'Ánh Xạ',
      noMappings: 'Không có ánh xạ nào được định nghĩa',
      fieldName: 'Tên Trường',
      alias: 'Bí Danh',
      editAlias: 'Chỉnh Sửa Bí Danh',
      fieldAlreadyExists: 'Trường đã tồn tại',
      newForwarder: 'Thêm Chuyển Tiếp',
      newReport: 'Thêm Báo Cáo',
      newUser: 'Thêm Người Dùng',
      changePassword: 'Đổi Mật Khẩu',
      newExportJob: 'Tạo Công Việc Xuất',
      editExportJob: 'Chỉnh Sửa Công Việc Xuất',
      playbook: 'Kịch bản',
      // Import Log
      uploadFile: 'Tải Lên Tệp',
      selectFile: 'Chọn Tệp',
      chooseFile: 'Chọn Tệp',
      dragDropFile: 'hoặc kéo thả tệp vào đây',
      fileName: 'Tên Tệp',
      fileSize: 'Kích Thước Tệp',
      uploadProgress: 'Tiến Độ Tải Lên',
      uploadSpeed: 'Tốc Độ Tải Lên',
      timeRemaining: 'Thời Gian Còn Lại',
      cancelUpload: 'Hủy Tải Lên',
      uploadComplete: 'Tải Lên Hoàn Thành',
      uploadFailed: 'Tải Lên Thất Bại',
      uploadCanceled: 'Tải Lên Đã Hủy',
      uploading: 'Đang Tải Lên',
      processing: 'Đang Xử Lý',
      validating: 'Đang Xác Thực',
      fileTooLarge: 'Tệp quá lớn',
      invalidFileType: 'Loại tệp không hợp lệ',
      supportedFormats: 'Định dạng được hỗ trợ',
      maxFileSize: 'Kích thước tệp tối đa',
      retryUpload: 'Thử Lại Tải Lên',
      validFile: 'Tệp Hợp Lệ',
      invalidFile: 'Tệp Không Hợp Lệ',
      fileEmpty: 'Tệp trống hoặc không hợp lệ',
      invalidFileName: 'Tên tệp không hợp lệ. Không được chứa ký tự đường dẫn',
      fileNameTooLong: 'Tên tệp quá dài (tối đa 255 ký tự)',
      fileNameEmpty: 'Tên tệp không được để trống',
      uploadHistory: 'Lịch Sử Tải Lên',
      progress: 'Tiến Độ',
      download: 'Tải Xuống',
      confirmDelete: 'Bạn có chắc chắn muốn xóa mục này?',
      deleteSuccess: 'Xóa mục thành công',
      deleteError: 'Không thể xóa mục',
      downloadError: 'Không thể tải xuống tệp',
      slaTitle: 'Thời Gian SLA Trung Bình',
      resTime: 'Thời Gian Phản Hồi Trung Bình',
      errorNoWidgets: 'Trang này đang trống',
      errorWidgetsCustomizing: 'Vui lòng lưu hoặc hủy tác vụ chỉnh sửa hiện tại',
      newAPIChannel: 'Thêm Kênh API',
      countLogSend: 'Số Log Đã Gửi',
      apiChannel: {
        httpConfig: 'Cấu Hình HTTP',
        sendCondition: 'Điều Kiện Gửi',
        payloadMapping: 'Ánh Xạ Payload',
        payloadPreview: 'Xem Trước JSON',
        queryFilter: 'Bộ Lọc Query',
        queryPlaceholder: 'Ví dụ: severity:high AND source:firewall',
        queryHelp: 'Nhập query để lọc log. Sử dụng * để khớp tất cả.',
        testQuery: 'Kiểm Tra Query',
        logsFound: 'Tìm thấy {total} log. Hiển thị 5 mới nhất:',
        logPreview: 'Xem Trước Log',
        queryError: 'Lỗi Query',
        scheduleHelp: 'Tần suất chạy kênh này',
        schedule30s: '30 giây',
        schedule1m: '1 phút',
        schedule5m: '5 phút',
        schedule15m: '15 phút',
        schedule30m: '30 phút',
        schedule1h: '1 giờ',
        schedule6h: '6 giờ',
        schedule12h: '12 giờ',
        schedule24h: '24 giờ',
        seconds: 'giây',
        minute: 'phút',
        minutes: 'phút',
        hour: 'giờ',
        hours: 'giờ',
        mapping: 'Ánh Xạ',
        constant: 'Hằng Số',
        selectField: 'Chọn trường',
        addField: 'Thêm Trường',
        errorKeyEmpty: 'Key không được để trống',
        errorDuplicateKey: 'Key bị trùng: {key}',
        errorSourceFieldRequired: 'Trường nguồn là bắt buộc cho key: {key}',
        stepBasicInfo: 'Thông Tin Cơ Bản',
        tabConfig: 'Cấu Hình',
        tabPayload: 'Ánh Xạ Payload',
        responseIndex: 'Index Lưu Response',
        noResponseIndex: 'Không lưu response',
        responseIndexHelp: 'Chọn index để lưu response từ API. Để trống nếu không cần lưu.'
      },
      none: 'Không có',
      notAvailable: 'N/A',
      online: 'Trực tuyến',
      offline: 'Ngoại tuyến',
      version: 'Phiên bản',
      yes: 'Có',
      no: 'Không',
      complete: 'Hoàn tất',
      all: 'Tất cả',
      saveAs: 'Lưu Thành',
      dashboardWidget: 'Widget Bảng Điều Khiển',
      reportWidget: 'Widget Báo Cáo',
      alert: 'Cảnh Báo',
      warning: 'Cảnh báo',
      savingTheQuery: 'Đang Lưu Truy Vấn',
      dashboard: 'Bảng Điều Khiển',
      // Additional upload translations
      upload: 'Tải Lên',
      selectFileToUpload: 'Chọn Tệp Để Tải Lên',
      fileSelected: 'Đã Chọn Tệp',
      readyToUpload: 'Sẵn sàng tải lên',
      startUpload: 'Bắt Đầu Tải Lên',
      selectIndexAndSourceType: 'Vui lòng chọn index và source type',
      uploadCompleted: 'Tải lên hoàn thành thành công',
      noUploadPermission: 'Bạn không có quyền tải lên tệp',
      taskDeletedSuccessfully: 'Xóa tác vụ thành công',
      sessionRemovedSuccessfully: 'Xóa phiên thành công',
      failedToRemoveSession: 'Không thể xóa phiên',
      paused: 'Đã tạm dừng',
      failed: 'Thất bại',
      completed: 'Hoàn thành',
      cancelled: 'Đã hủy',
      unknown: 'Không xác định',
      status: {
        status: "Trạng Thái",
        created: 'Đã Tạo',
        uploading: 'Đang Tải Lên',
        queued: 'Đang Chờ',
        processing: 'Đang Xử Lý',
        completed: 'Hoàn Thành',
        canceled: 'Đã Hủy',
        failed: 'Thất Bại'
      },
      pageOf: 'Trang {0}/{1}',
      startTime: 'Thời Gian Bắt Đầu',
      endTime: 'Thời Gian Kết Thúc',
      enterQuery: 'Nhập truy vấn tìm kiếm',
      id: 'ID',
      code: 'Mã',
      exportJob: {
        status: {
          pending: 'Đang Chờ',
          running: 'Đang Chạy',
          completed: 'Hoàn Thành',
          failed: 'Thất Bại',
          canceled: 'Đã Hủy'
        },
        confirmCancel: 'Bạn có chắc chắn muốn hủy công việc này?',
        downloadError: 'Không thể tải xuống tệp xuất'
      },
      route: {
        dashboards: 'Tổng Quan',
        search: 'Tìm Kiếm',
        alerts: 'Cảnh Báo',
        reports: 'Báo Cáo',
        incidents: 'Ứng phó sự cố',
        tickets: 'Vé',
        actions: 'Hành động',
        playBooks: 'Kịch bản',
        indexes: 'Chỉ Mục',
        sourceTypes: 'Kiểu Nguồn',
        dataInputs: 'Nguồn Dữ Liệu',
        mappings: 'Ánh Xạ',
        Settings: 'Cài Đặt',
        users: 'Người Dùng',
        forwarders: 'Chuyển Tiếp',
        apiChannels: 'Kênh API',
        parser: 'Cấu Hình Dữ Liệu',
        exportJobs: 'Công Việc Xuất',
        importLog: 'Nhập Nhật Ký',
        copyright: 'Bản Quyền',
        server: 'Máy Chủ'
      },
      subtitle: {
        search: 'Truy vấn và Trực quan hóa sự kiện',
        alerts: 'Giám sát dựa trên các số liệu',
        incidents: 'Quản lý ứng phó sự cố',
        tickets: 'Quản lý vé',
        actions: 'Quản lý hành động xử lý sự cố',
        playBooks: 'Quản lý kịch bản ứng phó sự cố',
        indexes: 'Quản lý các chỉ mục',
        reports: 'Báo cáo tổng quan về tình hình an ninh của hệ thống',
        sourceTypes: 'Định nghĩa các kiểu nguồn dữ liệu',
        dataInputs: 'Quản lý các nguồn dữ liệu',
        mappings: 'Quản lý ánh xạ trường Elasticsearch',
        users: 'Quản lý người dùng và phân quyền',
        forwarders: 'Chuyển tiếp bản ghi và theo dõi tài nguyên',
        apiChannels: 'Quản lý các kênh API',
        parser: 'Tạo các cấu hình Dữ Liệu',
        exportJobs: 'Quản lý và theo dõi công việc xuất dữ liệu',
        importLog: 'Nhập và xử lý tệp nhật ký để phân tích',
        copyright: 'Thông tin bản quyền',
        server: 'Trạng thái máy chủ và thông số hệ thống'
      },
      copyright: {
        sectionTitle: 'Bản quyền',
        company: 'Công ty',
        copyrightOwner: 'Bản quyền công nghệ',
        product: 'Sản phẩm',
        licenseCode: 'Mã bản quyền',
        softwareVersion: 'Phiên bản phần mềm',
        activationDate: 'Ngày kích hoạt',
        expirationDate: 'Ngày hết hạn',
        updateLicense: 'Cập nhật bản quyền thiết bị',
        updateLicenseInfo: 'Để sử dụng mã bản quyền khác, vui lòng lựa chọn Thay đổi mã bản quyền ở bên dưới. Trong trường hợp bạn không có Mã bản quyền, vui lòng liên hệ hotline {phone} hoặc email {email}.',
        contactInfo: 'Trong trường hợp bạn không có Mã bản quyền, vui lòng liên hệ hotline {phone} hoặc email {email}.'
      },
      chart: {
        type: 'Kiểu Biểu Đồ',
        pie: 'Biểu Đồ Tròn',
        line: 'Biểu Đồ Đường',
        bar: 'Biều Đồ Cột',
        error: 'Vui lòng thử lại sau',
        errorNoData: 'Không có dữ liệu hoặc loại biểu đồ không hợp lệ'
      },
      search: {
        result: 'Tất cả {total} sự kiện từ {start} đến {end}',
        errorNoCharts: 'Kết quả không thể trực quán hóa. Vui lòng sử dụng các lệnh gộp cụ thể hơn.',
        errorNoEvents: 'Không có sự kiện nào trong khoảng thời gian này. Vui lòng thay đổi truy vấn hoặc chọn một khoảng thời gian khác.',
        loading: 'Đang tải',
        query: 'Truy vấn',
        events: 'Sự kiện',
        visualization: 'Trực quan hóa',
        queryValidation: 'Xác thực truy vấn:',
        queryValidationMessage: 'Vui lòng đảm bảo truy vấn JSON của bạn hợp lệ trước khi gửi.',
        expandValue: 'Xem toàn bộ',
        collapseValue: 'Thu gọn'
      },
      report: {
        daily: 'Báo Cáo Hàng Ngày',
        weekly: 'Báo Cáo Hàng Tuần',
        monthly: 'Báo Cáo Hàng Tháng'
      },

      // DataTable component
      datatable: {
        search: 'Tìm kiếm...',
        itemsPerPage: 'Số mục mỗi trang',
        showing: 'Hiển thị {start} - {end} trong tổng số {total} bản ghi',
        noData: 'Không có dữ liệu',
        noResults: 'Không tìm thấy kết quả',
        page: 'Trang',
        of: 'của',
        previous: 'Trước',
        next: 'Tiếp',
        sortAscending: 'Sắp xếp tăng dần',
        sortDescending: 'Sắp xếp giảm dần'
      },

      users: {
        errorPasswordNotMatch: 'Mật khẩu nhắc lại không trùng khớp với mật khẩu mới',
        addUser: 'Thêm người dùng',
        updateUser: 'Cập nhật người dùng - {username}',
        searchPlaceholder: 'Tìm kiếm theo tên đăng nhập, email',
        serialNumber: 'STT',
        username: 'Tên đăng nhập',
        confirmPassword: 'Xác nhận mật khẩu',
        permissions: 'Quyền',
        role: 'Vai trò',
        status: 'Trạng thái',
        createdTime: 'Thời gian tạo',
        actions: 'Tác vụ',
        update: 'Cập nhật',
        resetPassword: 'Cài lại mật khẩu',
        activate: 'Kích hoạt',
        deactivate: 'Hủy kích hoạt',
        forceLogout: 'Đăng xuất cưỡng chế',
        selectPermission: 'Chọn quyền',
        currentStatus: 'Trạng thái hiện tại',
        confirmResetPassword: 'Bạn có chắc chắn muốn cài lại mật khẩu cho người dùng "{name}"?',
        confirmToggleStatus: 'Bạn có chắc chắn muốn {action} người dùng "{name}"?',
        passwordResetSuccess: 'Mật khẩu đã được cài lại thành công',
        passwordResetError: 'Có lỗi xảy ra khi cài lại mật khẩu',
        passwordChangeSuccess: 'Mật khẩu đã được thay đổi thành công',
        passwordChangeError: 'Có lỗi xảy ra khi thay đổi mật khẩu',
        oldPasswordIncorrect: 'Mật khẩu cũ không đúng',
        newPasswordSameAsOld: 'Mật khẩu mới phải khác với mật khẩu cũ',
        userStatusUpdateSuccess: 'Người dùng đã được {action} thành công',
        userStatusUpdateError: 'Có lỗi xảy ra khi {action} người dùng',
        userCreateError: 'Có lỗi xảy ra khi tạo người dùng',
        userUpdateError: 'Có lỗi xảy ra khi cập nhật người dùng',
        forceLogoutConfirmTitle: 'Đăng xuất cưỡng chế người dùng',
        forceLogoutConfirmMessage: 'Bạn có chắc chắn muốn đăng xuất cưỡng chế người dùng "{username}"?',
        forceLogoutWarning: 'Hành động này sẽ ngay lập tức chấm dứt tất cả các phiên đăng nhập đang hoạt động của người dùng này.',
        forceLogoutConfirmButton: 'Đăng xuất cưỡng chế',
        forceLogoutCancelButton: 'Hủy',
        forceLogoutSuccess: 'Người dùng "{name}" đã được đăng xuất cưỡng chế thành công',
        forceLogoutError: 'Có lỗi xảy ra khi đăng xuất cưỡng chế người dùng "{name}"',
        statusActive: 'Đang kích hoạt',
        statusInactive: 'Không kích hoạt',
        newPassword: 'Mật khẩu mới',
        enterNewPassword: 'Nhập mật khẩu mới',
        enterOldPassword: 'Nhập mật khẩu cũ',
        generateRandomPassword: 'Tạo mật khẩu ngẫu nhiên',
        copyPassword: 'Sao chép mật khẩu',
        passwordGenerated: 'Đã tạo mật khẩu thành công',
        passwordCopiedSuccess: 'Đã sao chép mật khẩu vào clipboard thành công',
        passwordCopyError: 'Không thể sao chép mật khẩu vào clipboard',
        showPassword: 'Hiển thị mật khẩu',
        hidePassword: 'Ẩn mật khẩu',
        itemsPerPage: 'Số mục mỗi trang',
        roles: {
          root: 'Root',
          admin: 'Admin',
          user: 'User',
          monitor: 'Monitor'
        },
        filter: {
          title: 'Bộ lọc',
          roles: 'Quyền',
          status: 'Trạng thái',
          confirm: 'Xác nhận',
          clearAll: 'Xóa tất cả bộ lọc',
          active: 'Đang kích hoạt',
          inactive: 'Không kích hoạt',
          resultCount: 'Tìm thấy {count} người dùng'
        },
        tooltips: {
          username: 'Tên đăng nhập phải dài 3-30 ký tự, chỉ chứa chữ cái, số và dấu gạch dưới, và phải duy nhất trong hệ thống.',
          email: 'Email phải có định dạng hợp lệ, duy nhất trong hệ thống và ít hơn 1000 ký tự.',
          password: 'Mật khẩu phải dài 8-60 ký tự, chỉ chứa ký tự ASCII (không hỗ trợ tiếng Việt), có ít nhất 1 chữ hoa, 1 chữ thường, 1 số và 1 ký tự đặc biệt.',
          confirmPassword: 'Mật khẩu xác nhận phải trùng khớp với mật khẩu đã nhập ở trên.'
        },
        placeholders: {
          username: 'Nhập tên đăng nhập',
          email: 'Nhập email',
          password: 'Nhập mật khẩu',
          confirmPassword: 'Nhập xác nhận mật khẩu'
        },
        validation: {
          emailRequired: 'Email là bắt buộc',
          emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ',
          emailTooLong: 'Email không được vượt quá 1000 ký tự',
          emailExists: 'Địa chỉ email này đã được sử dụng',
          usernameRequired: 'Tên đăng nhập là bắt buộc',
          usernameTooShort: 'Tên đăng nhập phải có ít nhất 3 ký tự',
          usernameTooLong: 'Tên đăng nhập không được vượt quá 30 ký tự',
          usernameNoSpaces: 'Tên đăng nhập không được chứa khoảng trắng',
          usernameInvalidChars: 'Tên đăng nhập không đúng quy định',
          usernameExists: 'Tên đăng nhập này đã được sử dụng',
          oldPasswordRequired: 'Vui lòng điền mật khẩu cũ',
          passwordRequired: 'Vui lòng điền mật khẩu mới',
          passwordTooShort: 'Mật khẩu phải có ít nhất 8 ký tự',
          passwordTooLong: 'Mật khẩu không được vượt quá 60 ký tự',
          passwordAsciiOnly: 'Mật khẩu chỉ được chứa ký tự ASCII (không hỗ trợ ký tự tiếng Việt)',
          passwordNeedsUppercase: 'Mật khẩu phải chứa ít nhất một chữ cái viết hoa',
          passwordNeedsLowercase: 'Mật khẩu phải chứa ít nhất một chữ cái viết thường',
          passwordNeedsNumber: 'Mật khẩu phải chứa ít nhất một chữ số',
          passwordNeedsSpecialChar: 'Mật khẩu phải chứa ít nhất một ký tự đặc biệt',
          confirmPasswordRequired: 'Vui lòng điền xác nhận mật khẩu',
          passwordsDoNotMatch: 'Xác nhận mật khẩu không trùng khớp',
          formHasErrors: 'Vui lòng sửa các lỗi xác thực trước khi gửi'
        },
        passwordRequirements: 'Mật khẩu phải có ít nhất 8 ký tự với chữ hoa, chữ thường và số'
      },
      sourceTypes: {
        name: "Tên Kiểu Nguồn",
        searchPlaceholder: 'Tìm kiếm theo Tên kiểu nguồn, Mô tả, Định dạng',
        format: 'Định dạng',
        filter: {
          title: 'Định dạng',
          confirm: 'Xác nhận',
          clearAll: 'Xóa tất cả bộ lọc',
          custom: 'tùy chỉnh'
        },
        form: {
          name: 'Tên Kiểu Nguồn',
          nameTooltip: 'Tên phải dài 3-30 ký tự, chỉ được chứa chữ cái, số, dấu gạch ngang, dấu gạch dưới và dấu chấm. Không khoảng trắng',
          namePlaceholder: 'Nhập tên kiểu nguồn',
          description: 'Mô tả',
          descriptionPlaceholder: 'Nhập mô tả',
          format: 'Định dạng',
          eventSeparator: 'Phân Cách Sự Kiện',
          eventSeparatorTooltip: 'Điền nội dung để phân biệt giữa các sự kiện',
          eventSeparatorPlaceholder: 'Nhập ký tự phân cách sự kiện',
          comment: 'Bình Luận',
          commentTooltip: 'Nội dung sau ký tự này sẽ bị bỏ qua và không được phân tích',
          commentPlaceholder: 'Nhập bình luận',
          timestampMode: 'Thời gian nhận log',
          autoTimestamp: 'Tự động điền thời gian hệ thống (Mặc định)',
          manualTimestamp: 'Sử dụng trường thời gian',
          timestampField: 'Tên Trường',
          timestampFieldPlaceholder: 'Nhập tên trường',
          timestampFormat: 'Định Dạng',
          timestampFormatPlaceholder: 'Nhập định dạng',
          fieldsList: 'Danh Sách Trường',
          fieldNamePlaceholder: 'Nhập tên trường',
          addField: 'Thêm',
          fieldsRequired: 'Cần ít nhất một trường',
          fieldSeparator: 'Phân Cách Trường',
          fieldSeparatorTooltip: 'Điền nội dung để phân biệt giữa các trường',
          fieldSeparatorPlaceholder: 'Nhập ký tự phân cách trường',
          regexp: 'RegEx',
          regexpPlaceholder: 'Nhập biểu thức chính quy',
          cancel: 'Hủy',
          confirm: 'Xác nhận'
        },
        validation: {
          nameRequired: 'Vui lòng điền tên kiểu nguồn',
          nameTooShort: 'Tên kiểu nguồn không đúng quy định',
          nameTooLong: 'Tên kiểu nguồn không được vượt quá 30 ký tự',
          nameInvalidChars: 'Tên kiểu nguồn không đúng quy định',
          nameExists: 'Tên kiểu nguồn đã tồn tại',
          eventSeparatorRequired: 'Vui lòng điền phân cách sự kiện',
          eventSeparatorNoSpaces: 'Phân cách sự kiện không được chứa khoảng trắng',
          fieldSeparatorRequired: 'Vui lòng điền phân cách trường',
          fieldSeparatorNoSpaces: 'Phân cách trường không được chứa khoảng trắng',
          commentNoSpaces: 'Bình luận không được chứa khoảng trắng',
          regexpRequired: 'Vui lòng điền RegEx',
          fieldsRequired: 'Vui lòng thêm trường vào danh sách',
          fieldNameRequired: 'Vui lòng thêm trường vào danh sách',
          fieldNameNoSpaces: 'Tên trường không được chứa khoảng trắng',
          timeFieldRequired: 'Vui lòng điền tên trường',
          timeFieldNoSpaces: 'Tên trường thời gian không được chứa khoảng trắng',
          timeFormatRequired: 'Vui lòng điền định dạng'
        },
        messages: {
          createSuccess: 'Thêm mới kiểu nguồn thành công',
          updateSuccess: 'Cập nhật kiểu nguồn thành công',
          createError: 'Thêm mới kiểu nguồn thất bại',
          updateError: 'Cập nhật kiểu nguồn thất bại',
          deleteSuccess: 'Xóa kiểu nguồn thành công',
          deleteError: 'Xóa kiểu nguồn thất bại'
        },
        updateTitle: 'Cập nhật kiểu nguồn - {name}',
        deleteConfirmation: {
          title: 'Xác nhận xóa kiểu nguồn',
          warningTitle: 'Cảnh báo xóa kiểu nguồn',
          message: 'Bạn có chắc chắn muốn xóa kiểu nguồn "{name}" không?',
          warning: 'Hành động này không thể hoàn tác.',
          countdown: 'Vui lòng đợi {seconds} giây trước khi có thể xóa...',
          confirm: 'Xác nhận',
          cancel: 'Hủy',
          dependencyWarning: 'Không xóa được kiểu nguồn này do đang được cấu hình ở:',
          dataInputLabel: 'Nguồn dữ liệu',
          forwarderLabel: 'Chuyển tiếp'
        },
        wizard: {
          button: 'Phát Hiện Thông Minh',
          title: 'Trình Hướng Dẫn Kiểu Nguồn',
          createTitle: 'Tạo Kiểu Nguồn',
          editTitle: 'Chỉnh Sửa Kiểu Nguồn',
          step: 'Bước {current} / {total}',
          previous: 'Quay Lại',
          next: 'Tiếp Theo',
          create: 'Tạo',
          update: 'Cập Nhật',
          fieldMapping: 'Ánh Xạ Trường',
          preview: 'Xem Trước',
          finalConfig: 'Cấu Hình Cuối Cùng',
          steps: {
            paste: 'Dán Log',
            detect: 'Phát Hiện',
            mapping: 'Ánh Xạ Trường',
            preview: 'Xem Trước',
            save: 'Lưu'
          },
          paste: {
            title: 'Dán Mẫu Log',
            description: 'Dán một hoặc nhiều dòng log mẫu để tự động phát hiện định dạng',
            placeholder: 'Dán mẫu log của bạn vào đây...\nMỗi dòng sẽ được phân tích riêng biệt.',
            detectButton: 'Phát Hiện Định Dạng',
            clearButton: 'Xóa'
          },
          detect: {
            title: 'Kết Quả Phát Hiện',
            description: 'Chọn định dạng phù hợp nhất cho log của bạn',
            noResults: 'Không phát hiện được định dạng. Vui lòng kiểm tra lại mẫu log.',
            confidence: 'Độ Tin Cậy',
            selectButton: 'Chọn'
          },
          mapping: {
            title: 'Ánh Xạ Trường',
            description: 'Tùy chọn cấu hình đổi tên trường và chuyển đổi kiểu dữ liệu',
            skipButton: 'Bỏ Qua',
            tabs: {
              rename: 'Đổi Tên Trường',
              typeCast: 'Chuyển Đổi Kiểu',
              positional: 'Vị Trí (CSV)',
              extract: 'Trích Xuất'
            },
            rename: {
              from: 'Tên Gốc',
              to: 'Tên Mới',
              add: 'Thêm Đổi Tên'
            },
            typeCast: {
              field: 'Trường',
              type: 'Kiểu',
              add: 'Thêm Chuyển Đổi Kiểu'
            },
            positional: {
              index: 'Chỉ Số',
              name: 'Tên Trường',
              type: 'Kiểu',
              add: 'Thêm Trường'
            },
            extract: {
              source: 'Trường Nguồn',
              pattern: 'Mẫu Regex',
              target: 'Trường Đích',
              add: 'Thêm Trích Xuất'
            }
          },
          parsePreview: {
            title: 'Xem Trước Phân Tích',
            description: 'Xem lại cách log của bạn sẽ được phân tích',
            rawLog: 'Log Gốc',
            parsedResult: 'Kết Quả Phân Tích',
            refreshButton: 'Làm Mới',
            success: 'Phân tích thành công',
            error: 'Phân tích thất bại'
          },
          save: {
            title: 'Lưu Kiểu Nguồn',
            description: 'Nhập tên cho kiểu nguồn mới của bạn',
            nameLabel: 'Tên',
            namePlaceholder: 'VD: FortiGate Firewall',
            descriptionLabel: 'Mô Tả',
            descriptionPlaceholder: 'Mô tả tùy chọn...'
          },
          buttons: {
            back: 'Quay Lại',
            next: 'Tiếp Theo',
            skip: 'Bỏ Qua',
            save: 'Lưu',
            cancel: 'Hủy'
          },
          messages: {
            detectSuccess: 'Phát hiện định dạng thành công',
            detectFailed: 'Phát hiện định dạng thất bại',
            previewSuccess: 'Đã cập nhật xem trước',
            previewFailed: 'Xem trước thất bại',
            saveSuccess: 'Tạo kiểu nguồn thành công',
            saveFailed: 'Tạo kiểu nguồn thất bại'
          },
          tiers: {
            tier0: 'Thô (Không Phân Tích)',
            tier1: 'Định Dạng Đã Biết',
            tier2: 'Dựa Trên Phân Cách',
            tier3: 'Mẫu',
            tier4: 'Regex'
          },
          parserTypes: {
            json: 'JSON',
            xml: 'XML',
            cef: 'CEF',
            syslog_kv: 'Key-Value',
            syslog_csv: 'CSV',
            dissect: 'Mẫu Dissect',
            drain: 'Mẫu Tự Động',
            regex: 'Biểu Thức Chính Quy'
          },
          createTitle: 'Tạo Kiểu Nguồn Mới',
          editTitle: 'Chỉnh Sửa Kiểu Nguồn',
          logSample: 'Mẫu Log',
          logSamplePlaceholder: 'Dán mẫu log của bạn vào đây...\nMỗi dòng sẽ được phân tích riêng biệt.',
          logSampleTooltip: 'Dán một hoặc nhiều dòng log để tự động phát hiện định dạng',
          detectFormat: 'Phát Hiện Định Dạng',
          fieldMapping: 'Ánh Xạ Trường',
          fieldMappingDescription: 'Cấu hình cách ánh xạ trường từ nguồn đến đích',
          fieldMappings: 'Các Ánh Xạ Trường',
          noFieldMappings: 'Chưa có ánh xạ trường nào',
          fieldMappingOptional: 'Ánh xạ trường là tùy chọn. Nhấn Tiếp Theo để tiếp tục.',
          parsedFields: 'Các Trường Đã Phát Hiện',
          addMapping: 'Thêm Ánh Xạ',
          enterSourceField: 'Nhập tên trường nguồn',
          enterTargetField: 'Nhập tên trường đích',
          csvMappingDescription: 'Ánh xạ vị trí cột CSV thành tên trường. Để trống để bỏ qua trường.',
          kvMappingDescription: 'Ánh xạ các trường key-value đã phát hiện thành tên tùy chỉnh. Để trống để giữ tên gốc.',
          parsedField: 'Trường Đã Phát Hiện',
          mappedName: 'Tên Ánh Xạ',
          position: 'Vị Trí',
          sampleValue: 'Giá Trị Mẫu',
          fieldName: 'Tên Trường',
          loadingFields: 'Đang tải trường...',
          noFieldsDetected: 'Không phát hiện được trường nào',
          loadFieldsError: 'Tải xem trước trường thất bại',
          configSummary: 'Tóm Tắt Cấu Hình',
          parserType: 'Loại Parser',
          tier: 'Cấp Độ',
          noSuggestionSelected: 'Vui lòng chọn một gợi ý phát hiện',
          sourceField: 'Trường Nguồn',
          targetField: 'Trường Đích',
          back: 'Quay Lại',
          next: 'Tiếp Theo',
          skip: 'Bỏ Qua',
          cancelConfirmTitle: 'Hủy Thay Đổi?',
          cancelConfirmMessage: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn hủy chúng không?',
          continueEditing: 'Tiếp Tục Chỉnh Sửa',
          discardChanges: 'Hủy Thay Đổi'
        },
        detection: {
          analyzing: 'Đang phân tích định dạng log...',
          confidence: 'Độ Tin Cậy',
          noSuggestions: 'Không phát hiện được định dạng',
          noSuggestionsHint: 'Thử dán các mẫu log khác',
          detectError: 'Phát hiện định dạng thất bại'
        },
        parsePreview: {
          rawLog: 'Log Gốc',
          parsedResult: 'Kết Quả Phân Tích',
          success: 'Phân tích thành công',
          failed: 'Phân tích thất bại',
          refresh: 'Làm Mới',
          showJson: 'Hiện JSON',
          hideJson: 'Ẩn JSON',
          field: 'Trường',
          value: 'Giá Trị',
          noRawLog: 'Không có log gốc',
          noResult: 'Không có kết quả phân tích',
          parseError: 'Lỗi phân tích',
          previewError: 'Lỗi xem trước'
        },
        fieldMapping: {
          rename: 'Đổi Tên',
          typeCast: 'Chuyển Đổi Kiểu',
          positional: 'Vị Trí',
          extract: 'Trích Xuất',
          oldFieldName: 'Tên Trường Gốc',
          newFieldName: 'Tên Trường Mới',
          fieldName: 'Tên Trường',
          index: 'Chỉ Số',
          regexPattern: 'Mẫu Regex',
          sourceField: 'Trường Nguồn',
          targetField: 'Trường Đích',
          selectField: 'Chọn trường...'
        },
        eventDelimiter: 'Phân Cách Sự Kiện',
        comment: 'Ký Tự Bình Luận',
        placeholders: {
          eventDelimiter: 'Nhập ký tự phân cách sự kiện (vd: \\n)',
          comment: 'Nhập ký tự bình luận (vd: #)'
        },
        tooltips: {
          eventDelimiter: 'Ký tự phân tách các sự kiện log. Mặc định là dấu xuống dòng (\\n).'
        },
        parserv2: {
          selectParserAndLog: 'Chọn Loại Parser và Nhập Log',
          selectParserAndLogDescription: 'Chọn loại parser và cung cấp log mẫu để phân tích',
          selectParser: 'Chọn Loại Parser',
          selectParserDescription: 'Chọn loại parser phù hợp với định dạng log của bạn',
          selectParserPlaceholder: 'Chọn một loại parser',
          loadingParsers: 'Đang tải danh sách parser...',
          loadParsersError: 'Không thể tải danh sách parser',
          sampleLog: 'Log Mẫu',
          inputLog: 'Nhập Log Mẫu',
          inputLogDescription: 'Nhập một log mẫu để kiểm tra và phân tích',
          logPlaceholder: 'Dán log mẫu vào đây...',
          parseButton: 'Phân Tích',
          parseError: 'Lỗi phân tích log',
          fieldMappingDescription: 'Ánh xạ các trường từ log nguồn sang các trường đích (tùy chọn)',
          noFieldsParsed: 'Chưa có trường nào được phân tích từ log',
          sourceField: 'Trường Nguồn',
          sampleValue: 'Giá Trị Mẫu',
          targetField: 'Trường Đích',
          previewDescription: 'Xem lại cấu hình parser trước khi lưu',
          finalConfigDescription: 'Nhập thông tin cơ bản để hoàn tất',
          parserType: 'Loại Parser',
          fieldsDetected: 'Số trường phát hiện',
          fieldsMapped: 'Số trường đã ánh xạ',
          mappingsSummary: 'Tóm tắt ánh xạ',
          noMappings: 'Chưa có ánh xạ nào',
          namePlaceholder: 'Nhập tên kiểu nguồn',
          descriptionPlaceholder: 'Nhập mô tả (tùy chọn)'
        }
      },
      logout: {
        confirmTitle: 'Xác Nhận Đăng Xuất',
        confirmMessage: 'Bạn có chắc chắn muốn đăng xuất?',
        confirmButton: 'Ok',
        cancelButton: 'Hủy'
      },
      teible: {
        showing: 'Hiển thị',
        total: 'trên tổng số {count} bản ghi',
        last: 'bản ghi cuối cùng',
        empty: 'Không có dữ liệu',
        filter: 'Tìm kiếm...'
      },
      forwarderDisabledMessage: 'Các cài đặt đang bị ẩn vì forwarder đang bị vô hiệu hóa. Bật forwarder để xem và chỉnh sửa cài đặt.',
      forwarders: {
        searchPlaceholder: 'Tìm kiếm theo Tên chuyển tiếp, Mô tả',
        loadError: 'Không thể tải danh sách chuyển tiếp',
        downloadAgent: 'Tải xuống Agent',
        uploadNewVersion: 'Upload Phiên Bản Mới',
        chooseFile: 'Chọn tệp',
        dragDropFile: 'hoặc kéo thả tệp đính kèm',
        uploadSuccess: 'Tải lên tệp thành công',
        systemLog: 'Nhật ký hệ thống',
        resourceMonitor: 'Theo dõi tài nguyên',
        fileLog: 'Nhật ký tệp tin',
        enableWindows: 'Kích hoạt Windows',
        enableLinux: 'Kích hoạt Linux',
        windowsX64: 'Windows x64',
        windowsX32: 'Windows x32',
        linuxX64: 'Linux x64',
        linuxX32: 'Linux x32',
        inputText: 'Nhập văn bản',
        fileFormatInfo: 'Định dạng .ZIP | Dung lượng tối đa: 100MB',
        agents: 'Agents',
        agentsSubtitle: 'Danh sách các agent đã cài đặt',
        hostname: 'Tên máy chủ',
        macAddress: 'Địa chỉ MAC',
        ips: 'IPs',
        noIPs: 'Không có IP',
        lastSeen: 'Lần cuối thấy',
        releasedVersions: 'Các phiên bản đã phát hành',
        releaseDate: 'Ngày phát hành',
        os: 'Hệ điều hành',
        architecture: 'Kiến trúc',
        stable: 'Ổn định',
        editVersion: 'Chỉnh sửa Phiên bản',
        stableVersion: 'Phiên bản Ổn định',
        stableVersionHelp: 'Phiên bản ổn định không thể thay đổi trở lại không ổn định.',
        pleaseUploadAtLeastOneFile: 'Vui lòng tải lên ít nhất một tệp',
        cannotUploadNewVersion: 'Không thể tải lên phiên bản mới',
        versionUpdatedSuccessfully: 'Cập nhật phiên bản thành công',
        failedToUpdateVersion: 'Không thể cập nhật phiên bản',
        failedToDownloadAgent: 'Không thể tải xuống tệp cài đặt agent',
        deleteAgentConfirm: 'Xóa agent "{name}"?',
        deleteAgentWarning: 'Hành động này không thể hoàn tác.',
        description: 'Mô tả',
        fileFormat: 'Định dạng .ZIP | Dung lượng tối đa: 100MB',
        cancel: 'Hủy',
        complete: 'Hoàn tất',
        uploadNewVersionBtn: 'Tải lên phiên bản mới',
        pleaseUploadFile: 'Vui lòng tải lên ít nhất một tệp',
        uploadError: 'Không thể tải lên phiên bản mới',
        selectIndex: 'Chọn chỉ mục',
        selectSourceType: 'Chọn kiểu nguồn',
        selectChannel: 'Chọn kênh',
        sourceType: 'Kiểu nguồn',
        noSuitableSourceType: 'Không có kiểu nguồn phù hợp',
        logSendInterval: 'Khoảng thời gian gửi bản ghi',
        batchSize: 'Số lượng bản ghi',
        checkInterval: 'Khoảng thời gian kiểm tra',
        metrics: 'Chỉ số',
        channels: 'Kênh',
        customPaths: 'Đường dẫn tùy chỉnh',
        paths: 'Đường dẫn',
        excludes: 'Loại trừ',
        stream: 'Luồng',
        streamName: 'Tên luồng',
        addStream: 'Thêm luồng',
        removeStream: 'Xóa luồng này',
        noStreamsAdded: 'Chưa có luồng nào được thêm.',
        enterLogPath: 'Nhập đường dẫn tệp bản ghi',
        enterExcludePattern: 'Nhập mẫu loại trừ (nếu có)',
        version: 'Phiên bản',
        stableVersionNote: 'Phiên bản ổn định không thể thay đổi trở lại không ổn định.',
        yes: 'Có',
        no: 'Không',
        none: 'Không có',
        online: 'Trực tuyến',
        offline: 'Ngoại tuyến',
        downloadAgentError: 'Không thể tải xuống tệp cài đặt agent',
        noStreams: 'Chưa có luồng nào được thêm',
        basicInfo: 'Thông tin cơ bản',
        currentStep: 'Bước đang thực hiện',
        back: 'Quay lại',
        continue: 'Tiếp tục',
        confirm: 'Xác nhận',
        forwarderName: 'Tên chuyển tiếp',
        forwarderType: 'Loại chuyển tiếp',
        enterForwarderName: 'Nhập tên chuyển tiếp',
        enterDescription: 'Nhập mô tả',
        nameRules: 'Quy định về tên',
        nameRuleNotEmpty: 'Không được để trống',
        nameRuleNotDuplicate: 'Không được trùng',
        nameRuleNoSpace: 'Không được nhập dấu cách, không được nhập kí tự đặc biệt (trừ 3 kí tự: gạch ngang "-", gạch dưới "_" và dấu chấm ".")',
        nameRuleLength: 'Số lượng kí tự: tối thiểu 3, tối đa 30',
        tokenHelp: 'Mã được sử dụng làm mã kết nối',
        regenerateToken: 'Tạo ngẫu nhiên mới mã',
        copyToken: 'Sao chép mã',
        tokenCopied: 'Đã sao chép mã token',
        selectAtLeastOneModule: 'Vui lòng chọn ít nhất một loại bản ghi',
        moduleNotSelected: 'Mô-đun này chưa được chọn',
        sendLogConfig: 'Cấu hình mốc gửi bản ghi',
        timeInterval: 'Khoảng thời gian',
        timeIntervalHelp: 'Khoảng thời gian giữa các lần gửi bản ghi',
        timeIntervalUnit: 'Đơn vị: giây',
        enterTimeInterval: 'Nhập khoảng thời gian',
        logCount: 'Số lượng nhật ký',
        logCountHelp: 'Số lượng nhật ký gửi mỗi lô',
        enterLogCount: 'Nhập số lượng nhật ký',
        channel: 'Kênh',
        channelHelp: 'Chọn các kênh để theo dõi',
        enterChannelPath: 'Nhập đường dẫn kênh và nhấn Enter',
        customPath: 'Đường dẫn tùy chỉnh',
        customPathHelp: 'Nhập đường dẫn tùy chỉnh',
        enterCustomPath: 'Nhập đường dẫn tùy chỉnh',
        noIndexAvailable: 'Không có chỉ mục khả dụng',
        noSourceTypeAvailable: 'Không có kiểu nguồn khả dụng',
        noChannelAvailable: 'Không có kênh khả dụng',
        checkIntervalHelp: 'Khoảng thời gian kiểm tra chỉ số tài nguyên',
        checkIntervalUnit: 'Đơn vị: giây',
        enterCheckInterval: 'Nhập khoảng thời gian kiểm tra',
        metricsHelp: 'Chọn các chỉ số để theo dõi',
        metricCPU: 'CPU',
        metricRAM: 'RAM',
        metricDisk: 'Ổ đĩa',
        metricNetwork: 'Mạng',
        fileStreams: 'Luồng tệp',
        noStreamsConfigured: 'Chưa cấu hình luồng nào',
        filePath: 'Đường dẫn tệp',
        filePaths: 'Đường dẫn tệp',
        enterFilePath: 'Nhập đường dẫn tệp',
        enterFilePaths: 'Nhập đường dẫn và nhấn Enter',
        filePathsHelp: 'Nhập mỗi đường dẫn và nhấn Enter',
        excludePaths: 'Loại trừ đường dẫn',
        enterExcludePaths: 'Nhập đường dẫn và nhấn Enter',
        excludePathsHelp: 'Nhập đường dẫn cần loại trừ và nhấn Enter',
        enterStreamName: 'Nhập tên luồng',
        cancelCreateTitle: 'Hủy tạo mới chuyển tiếp',
        cancelCreateMessage: 'Bạn có chắc chắn muốn hủy tạo mới chuyển tiếp không?',
        addForwarderSuccess: 'Thêm mới chuyển tiếp thành công!',
        addForwarderFailed: 'Thêm mới chuyển tiếp thất bại',
        pleaseCompleteAllRequiredFields: 'Vui lòng điền đầy đủ các trường bắt buộc',
        pleaseEnterForwarderName: 'Vui lòng điền tên chuyển tiếp',
        nameTooShort: 'Tên chuyển tiếp không đúng quy định',
        nameTooLong: 'Tên chuyển tiếp không được vượt quá 30 ký tự',
        nameInvalidCharacters: 'Tên chuyển tiếp không đúng quy định',
        nameExists: 'Tên chuyển tiếp đã tồn tại',
        forwarderNameInvalid: 'Tên chuyển tiếp không hợp lệ',
        pleaseSelectAtLeastOneModule: 'Vui lòng chọn ít nhất một loại bản ghi',
        pleaseConfigureSystemLog: 'Vui lòng cấu hình bản ghi hệ thống',
        intervalRangeError: 'Khoảng thời gian phải từ 3 đến 86400 giây',
        timeIntervalRules: 'Quy định khoảng thời gian',
        timeIntervalRuleMin: 'Giá trị tối thiểu: 3 giây',
        timeIntervalRuleMax: 'Giá trị tối đa: 86400 giây',
        logCountRules: 'Quy định số lượng nhật ký',
        logCountRuleMin: 'Giá trị tối thiểu: 1',
        logCountRuleMax: 'Giá trị tối đa: 999999',
        checkIntervalRules: 'Quy định khoảng thời gian kiểm tra',
        checkIntervalRuleMin: 'Giá trị tối thiểu: 3 giây',
        checkIntervalRuleMax: 'Giá trị tối đa: 86400 giây',
        checkIntervalRangeError: 'Khoảng thời gian kiểm tra phải từ 3 đến 86400 giây',
        batchSizeRangeError: 'Số lượng nhật ký phải từ 1 đến 999999',
        streamNameMaxLength: 'Max 30 ký tự',
        streamNameRequired: 'Vui lòng điền tên luồng',
        streamNameInvalid: 'Tên luồng không đúng quy định',
        streamNameDuplicate: 'Tên luồng đã tồn tại',
        filePathsRequired: 'Vui lòng nhập đường dẫn',
        filePathsTooltip: 'Nhập đường dẫn thu thập log và nhấn Enter',
        excludePathsTooltip: 'Nhập đường dẫn không muốn thu thập log và nhấn Enter',
        pleaseConfigureResourceMonitor: 'Vui lòng cấu hình theo dõi tài nguyên',
        pleaseConfigureFileLog: 'Vui lòng cấu hình nhật ký tệp tin',
        pleaseCompleteBasicInfoFirst: 'Vui lòng hoàn thành thông tin cơ bản trước',
        validation: {
          completeExistingStreams: 'Vui lòng hoàn thành cấu hình Chỉ mục và Kiểu nguồn cho các luồng hiện có trước khi thêm luồng mới.'
        }
      },

      dataInputs: {
        searchPlaceholder: 'Tìm kiếm theo Tên nguồn dữ liệu, Mô tả',
        messages: {
          createSuccess: 'Tạo nguồn dữ liệu thành công',
          updateSuccess: 'Cập nhật nguồn dữ liệu thành công',
          deleteSuccess: 'Xóa nguồn dữ liệu thành công',
          activateSuccess: 'Kích hoạt nguồn dữ liệu thành công',
          deactivateSuccess: 'Hủy kích hoạt nguồn dữ liệu thành công',
          createError: 'Tạo nguồn dữ liệu thất bại',
          updateError: 'Cập nhật nguồn dữ liệu thất bại',
          deleteError: 'Xóa nguồn dữ liệu thất bại',
          activateError: 'Kích hoạt nguồn dữ liệu thất bại',
          deactivateError: 'Hủy kích hoạt nguồn dữ liệu thất bại',
          fetchError: 'Tải danh sách nguồn dữ liệu thất bại'
        },
        tooltips: {
          name: 'Tên nguồn dữ liệu phải dài 3-30 ký tự, chỉ chứa chữ cái, số, dấu gạch ngang, dấu gạch dưới và dấu chấm, và phải duy nhất trong hệ thống.',
          description: 'Mô tả tùy chọn cho nguồn dữ liệu. Tối đa 4096 ký tự.',
          tokenCode: 'Mã được sử dụng làm định danh kết nối từ CyEDR đến CySIEM',
          ssl: 'Bật mã hóa truyền tải, chỉ kích hoạt khi nguồn log có cấu hình này',
          allowedIPs: 'Nhập các IP được phép gửi log đến hệ thống, để trống để cho phép tất cả IP',
          port: 'Số cổng phải nằm trong khoảng từ 0 đến 65535',
          generateToken: 'Tạo token ngẫu nhiên mới',
          copyToken: 'Sao chép token',
          index: 'Chọn index nơi log sẽ được lưu trữ',
          sourceType: 'Chọn kiểu nguồn để phân tích log'
        },
        validation: {
          nameRequired: 'Tên nguồn dữ liệu là bắt buộc',
          nameTooShort: 'Tên nguồn dữ liệu không đúng quy định',
          nameTooLong: 'Tên nguồn dữ liệu không đúng quy định',
          nameInvalidChars: 'Tên nguồn dữ liệu không đúng quy định',
          nameExists: 'Tên nguồn dữ liệu đã tồn tại',
          descriptionTooLong: 'Mô tả không được vượt quá {max} ký tự',
          portRequired: 'Vui lòng điền cổng',
          portInvalid: 'Cổng phải là một số hợp lệ',
          portOutOfRange: 'Cổng phải nằm trong khoảng từ 0 đến 65535',
          portReserved: 'Cổng 80 và 443 là cổng dành riêng và không thể sử dụng',
          portExists: 'Cổng đã tồn tại cho giao thức này',
          ipRequired: 'Địa chỉ IP là bắt buộc',
          ipTooLong: 'Địa chỉ IP không được vượt quá 16 ký tự',
          ipInvalidFormat: 'Định dạng địa chỉ IP không hợp lệ',
          ipInvalidRange: 'Các octet của địa chỉ IP phải nằm trong khoảng từ 0 đến 255',
          ipDuplicate: 'Địa chỉ IP này đã tồn tại trong danh sách',
          indexRequired: 'Vui lòng chọn Chỉ Mục',
          sourceTypeRequired: 'Vui lòng chọn Kiểu nguồn',
          formInvalid: 'Vui lòng sửa các lỗi xác thực trước khi gửi'
        },
        placeholders: {
          name: 'Nhập tên nguồn dữ liệu',
          description: 'Nhập mô tả cho nguồn dữ liệu này...',
          port: 'Nhập số cổng',
          accessIPs: 'Nhập IP và nhấn Enter'
        },
        labels: {
          token: 'Token',
          port: 'Cổng',
          accessIPs: 'Các IP có quyền truy cập'
        },
        deleteConfirmation: {
          title: 'Xóa nguồn dữ liệu',
          message: 'Bạn có chắc chắn muốn xóa nguồn dữ liệu "{name}"?',
          warning: 'Lưu ý: Thao tác này không thể hoàn tác, vui lòng kiểm tra kĩ trước khi xác nhận!',
          countdown: 'Vui lòng đợi {seconds} giây trước khi có thể xóa...',
          confirm: 'Xác nhận',
          cancel: 'Hủy'
        },
        statusConfirmation: {
          activateTitle: 'Xác nhận kích hoạt nguồn dữ liệu - {name}',
          deactivateTitle: 'Xác nhận hủy kích hoạt nguồn dữ liệu - {name}',
          activateMessage: 'Bạn có chắc chắn muốn kích hoạt nguồn dữ liệu này?',
          deactivateMessage: 'Bạn có chắc chắn muốn hủy kích hoạt nguồn dữ liệu này?',
          confirm: 'Xác nhận',
          cancel: 'Hủy'
        }
      },

      indexes: {
        searchPlaceholder: 'Tìm kiếm theo Tên chỉ mục, Mô tả',
        searchHelp: 'Tìm kiếm theo Tên chỉ mục, Mô tả',
        addIndexTitle: 'Thêm Chỉ Mục',
        editIndexTitle: 'Cập nhật chỉ mục - {indexName}',
        indexName: 'Tên chỉ mục',
        indexDescription: 'Mô tả',
        maxSize: 'Kích cỡ tối đa',
        maxStorageTime: 'Thời gian lưu trữ tối đa',
        status: 'Trạng thái',
        statusEnabled: 'Đã bật',
        statusDisabled: 'Đã tắt',
        confirmButton: 'Xác nhận',
        cancelButton: 'Hủy',
        unitDay: 'Ngày',
        unitDays: 'Ngày',
        unitHour: 'Giờ',
        unitHours: 'Giờ',
        noData: 'Không có dữ liệu',
        unlimited: 'Không giới hạn',
        enableIndex: 'Bật index',
        createSuccess: 'Thêm mới chỉ mục thành công',
        updateSuccess: 'Cập nhật chỉ mục thành công',
        columnLabels: {
          name: 'Tên chỉ mục',
          size: 'Kích cỡ hiện tại/Kích cỡ tối đa',
          storageDuration: 'Thời gian lưu trữ/Thời gian lưu trữ tối đa',
          createdAt: 'Thời gian tạo',
          actions: 'Tác vụ'
        },
        actions: {
          update: 'Cập nhật'
        },
        filter: {
          title: 'Bộ lọc',
          statusActive: 'Đang kích hoạt',
          statusInactive: 'Không kích hoạt',
          confirm: 'Xác nhận',
          clearAll: 'Xóa tất cả bộ lọc'
        },
        validation: {
          nameRequired: 'Hãy điền tên chỉ mục',
          nameTooShort: 'Tên chỉ mục không đúng quy định',
          nameTooLong: 'Tên index không được vượt quá 30 ký tự',
          nameInvalidChars: 'Tên chỉ mục không đúng quy định',
          nameNoUppercase: 'Tên index không hợp lệ',
          nameExists: 'Tên chỉ mục đã tồn tại',
          descriptionTooLong: 'Mô tả không được vượt quá {max} ký tự',
          maxSizeRequired: 'Kích thước tối đa là bắt buộc',
          maxSizeInvalid: 'Kích thước tối đa phải là một số hợp lệ',
          rotateTimeRequired: 'Thời gian xoay vòng là bắt buộc',
          rotateTimeInvalid: 'Thời gian xoay vòng phải là một số hợp lệ',
          formHasErrors: 'Vui lòng sửa các lỗi xác thực trước khi gửi'
        },
        tooltips: {
          name: 'Bắt buộc. 3-30 ký tự. Chỉ chữ cái thường, số, gạch ngang (-), gạch dưới (_), dấu chấm (.). Không được sử dụng chữ viết hoa. Không trùng lặp. Không khoảng trắng',
          description: 'Tùy chọn. Tối đa 4096 ký tự.',
          maxSize: 'Khi dung lượng lưu trữ đạt giá trị tối đa thì hệ thống sẽ xóa lưu trữ ở ngày cũ nhất',
          rotateTime: 'Khi số ngày lưu trữ đạt giá trị tối đa thì hệ thống sẽ xóa lưu trữ ở ngày cũ nhất',
          enabled: 'Bật hoặc tắt index này.'
        },
        placeholders: {
          name: 'Nhập tên chỉ mục',
          description: 'Nhập mô tả',
          maxSize: '10',
          rotateTime: '90'
        },
        deleteConfirmation: {
          title: 'Xóa chỉ mục - {indexName}',
          warningTitle: 'Cảnh báo xóa chỉ mục',
          message: 'Bạn có chắc chắn muốn xóa chỉ mục này?',
          warning: 'Lưu ý: Thao tác này không thể hoàn tác, vui lòng kiểm tra kĩ trước khi xác nhận!',
          countdown: 'Vui lòng chờ {seconds} giây trước khi xác nhận...',
          confirm: 'Xác nhận',
          cancel: 'Hủy',
          dependencyWarning: 'Không xóa được chỉ mục này do đang được cấu hình ở:',
          dataInputLabel: 'Nguồn dữ liệu:',
          forwarderLabel: 'Chuyển tiếp:'
        },
        deleteSuccess: 'Xóa chỉ mục thành công!',
        activateSuccess: 'Kích hoạt chỉ mục thành công!',
        deactivateSuccess: 'Hủy kích hoạt chỉ mục thành công!',
        statusConfirmation: {
          activateTitle: 'Kích hoạt chỉ mục - {indexName}',
          deactivateTitle: 'Hủy kích hoạt chỉ mục - {indexName}',
          activateMessage: 'Bạn có chắc chắn muốn kích hoạt chỉ mục này?',
          deactivateMessage: 'Bạn có chắc chắn muốn hủy kích hoạt chỉ mục này?',
          confirm: 'Xác nhận',
          cancel: 'Hủy'
        },
        cancelTitle: 'Xác nhận hủy',
        cancelMessage: 'Bạn có chắc chắn muốn hủy? Các thay đổi sẽ không được lưu.'
      },

      // dataInputs: {
      //   searchPlaceholder: 'Tìm kiếm theo tên, mô tả',
      //   messages: {
      //     createSuccess: 'Thêm nguồn dữ liệu thành công',
      //     updateSuccess: 'Cập nhật nguồn dữ liệu thành công',
      //     deleteSuccess: 'Xóa nguồn dữ liệu thành công',
      //     activateSuccess: 'Kích hoạt nguồn dữ liệu thành công',
      //     deactivateSuccess: 'Hủy kích hoạt nguồn dữ liệu thành công',
      //     createError: 'Thêm nguồn dữ liệu thất bại',
      //     updateError: 'Cập nhật nguồn dữ liệu thất bại',
      //     deleteError: 'Xóa nguồn dữ liệu thất bại',
      //     activateError: 'Kích hoạt nguồn dữ liệu thất bại',
      //     deactivateError: 'Hủy kích hoạt nguồn dữ liệu thất bại',
      //     fetchError: 'Không thể tải danh sách nguồn dữ liệu'
      //   },
      //   tooltips: {
      //     name: 'Tên nguồn dữ liệu phải từ 3-30 ký tự, chỉ chứa chữ cái, số, gạch ngang, gạch dưới và dấu chấm, không trùng lặp trong hệ thống.',
      //     description: 'Mô tả tùy chọn cho nguồn dữ liệu. Tối đa 4096 ký tự.',
      //     tokenCode: 'Mã được sử dụng làm định danh kết nối từ CyEDR đến CySIEM',
      //     ssl: 'Bật mã hóa truyền tải, chỉ kích hoạt khi nguồn log có cấu hình này',
      //     allowedIPs: 'Nhập các IP được phép gửi log đến hệ thống, để trống để cho phép tất cả IP',
      //     port: 'Số cổng phải từ 0 đến 65535',
      //     generateToken: 'Tạo token ngẫu nhiên mới',
      //     copyToken: 'Sao chép token',
      //     index: 'Chọn chỉ mục nơi log sẽ được lưu trữ',
      //     sourceType: 'Chọn kiểu nguồn để phân tích log'
      //   },
      //   validation: {
      //     nameRequired: 'Tên nguồn dữ liệu là bắt buộc',
      //     nameTooShort: 'Tên nguồn dữ liệu không đúng.',
      //     nameTooLong: 'Tên nguồn dữ liệu không đúng.',
      //     nameInvalidChars: 'Tên nguồn dữ liệu không đúng.',
      //     nameExists: 'Tên nguồn dữ liệu đã tồn tại',
      //     descriptionTooLong: 'Mô tả không được vượt quá {max} ký tự',
      //     portRequired: 'Vui lòng nhập số cổng',
      //     portInvalid: 'Cổng phải là một số hợp lệ',
      //     portOutOfRange: 'Cổng phải từ 0 đến 65535',
      //     portReserved: 'Cổng 80 và 443 đã được dành riêng và không thể sử dụng',
      //     portExists: 'Cổng đã tồn tại cho giao thức này',
      //     ipRequired: 'Địa chỉ IP là bắt buộc',
      //     ipTooLong: 'Địa chỉ IP không được vượt quá 16 ký tự',
      //     ipInvalidFormat: 'Định dạng địa chỉ IP không hợp lệ',
      //     ipInvalidRange: 'Các octet của địa chỉ IP phải từ 0 đến 255',
      //     ipDuplicate: 'Địa chỉ IP này đã tồn tại trong danh sách',
      //     indexRequired: 'Chỉ mục là bắt buộc',
      //     sourceTypeRequired: 'Kiểu nguồn là bắt buộc',
      //     formInvalid: 'Vui lòng sửa các lỗi xác thực trước khi gửi'
      //   },
      //   placeholders: {
      //     name: 'Nhập tên nguồn dữ liệu',
      //     description: 'Nhập mô tả cho nguồn dữ liệu này...',
      //     port: 'Nhập số cổng',
      //     accessIPs: 'Nhập IP và nhấn Enter'
      //   },
      //   labels: {
      //     token: 'Token',
      //     port: 'Cổng',
      //     accessIPs: 'IP truy cập'
      //   },
      //   deleteConfirmation: {
      //     title: 'Xác nhận xóa nguồn dữ liệu',
      //     message: 'Bạn có chắc chắn muốn xóa nguồn dữ liệu "{name}" không?',
      //     warning: 'Hành động này không thể hoàn tác.',
      //     countdown: 'Vui lòng đợi {seconds} giây trước khi có thể xóa...',
      //     confirm: 'Xác nhận',
      //     cancel: 'Hủy'
      //   },
      //   statusConfirmation: {
      //     activateTitle: 'Xác nhận kích hoạt nguồn dữ liệu - {name}',
      //     deactivateTitle: 'Xác nhận hủy kích hoạt nguồn dữ liệu - {name}',
      //     activateMessage: 'Bạn có chắc chắn muốn kích hoạt nguồn dữ liệu này không?',
      //     deactivateMessage: 'Bạn có chắc chắn muốn hủy kích hoạt nguồn dữ liệu này không?',
      //     confirm: 'Xác nhận',
      //     cancel: 'Hủy'
      //   }
      // },
      twoFactor: {
        title: 'Xác thực hai yếu tố',
        setupTitle: 'Thiết lập xác thực hai yếu tố',
        enterCode: 'Nhập mã 6 chữ số từ ứng dụng xác thực của bạn',
        codePlaceholder: 'Nhập mã',
        verify: 'Xác minh',
        enabled: 'Đã bật 2FA thành công!',
        disabled: 'Đã tắt 2FA',
        enable: 'Bật 2FA',
        disable: 'Tắt 2FA',
        status: 'Trạng thái 2FA',
        scanQrCode: 'Quét mã QR này bằng ứng dụng xác thực (Google Authenticator, Authy, v.v.)',
        manualEntry: 'Không thể quét? Nhập mã này thủ công:',
        enterCodeToVerify: 'Nhập mã 6 chữ số từ ứng dụng xác thực để hoàn tất thiết lập:',
        saveRecoveryCodes: 'Lưu các mã khôi phục này ở nơi an toàn. Bạn có thể sử dụng chúng để truy cập tài khoản nếu mất thiết bị xác thực.',
        recoveryCodes: 'Mã khôi phục',
        regenerateRecoveryCodes: 'Tạo lại mã khôi phục',
        useRecoveryCode: 'Sử dụng mã khôi phục',
        useAuthenticator: 'Sử dụng mã xác thực',
        backToLogin: 'Quay lại đăng nhập',
        codeRequired: 'Vui lòng nhập mã',
        invalidCode: 'Mã xác thực không hợp lệ',
        verificationFailed: 'Xác minh thất bại',
        passwordRequired: 'Vui lòng nhập mật khẩu',
        statusEnabled: '2FA đang được bật',
        statusDisabled: '2FA chưa được bật',
        enabledSince: 'Đã bật từ',
        disableTitle: 'Tắt xác thực hai yếu tố',
        disableWarning: 'Tắt 2FA sẽ làm giảm bảo mật tài khoản của bạn.',
        verificationCode: 'Mã xác nhận',
        regenerateWarning: 'Hành động này sẽ vô hiệu hóa các mã khôi phục hiện tại của bạn.',
        regenerate: 'Tạo lại'
      }
    }
  }
}
